
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as login_46dofM_45WYrv8qfkzRmiVu6RHDAxLkz6JdpLhbBurAw7Ywq4Meta } from "/app/pages/login.do.vue?macro=true";
import { default as dashboardMP4s_45_45Pnrs3lAogdEWxQSVgBglFzEw4XrIvkluYCTzEMeta } from "/app/pages/dashboard.vue?macro=true";
import { default as indexplGRes0_4ASSl0mKMZvvIXn69JkKA7WRu_45r3LrS2gjAMeta } from "/app/pages/guide/index.vue?macro=true";
import { default as index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta } from "/app/pages/login/index.vue?macro=true";
import { default as TagJnoZVYb4e0SrdUqSu9hja_45SfSYQx8znIf3bqMfgNQYMMeta } from "/app/pages/components/Tag.vue?macro=true";
import { default as Testa7KgrWxjua6hgbAuZwKDCFXemoW0Z43AF8O8ridRlnwMeta } from "/app/pages/components/Test.vue?macro=true";
import { default as AlertQAMlF5tmwXmADhpd5GSi5KFq9PYWKeq6CwSmStaMGu4Meta } from "/app/pages/components/Alert.vue?macro=true";
import { default as indexNkZbUqxWsUgd3s6qpEO1Z9V4YnIIMOFpW677RSKkAGUMeta } from "/app/pages/components/index.vue?macro=true";
import { default as InputxBwvReoI09DJNm_YvjdgIEj9fxhrqYNjgET1Srma_70Meta } from "/app/pages/components/Input.vue?macro=true";
import { default as PopupwBAxIi8cAGXWPm7CKlRo_453GZd6SW7iXV73YNt5you_45UMeta } from "/app/pages/components/Popup.vue?macro=true";
import { default as RadioiSp8Ovl1po3iG087UHEJtJgpu0qxEjXjtGsmwrTz9S4Meta } from "/app/pages/components/Radio.vue?macro=true";
import { default as ButtonhNAJ3knW55OBKeymNOlEocBSpwxqzWn5QrEcjlQw6j4Meta } from "/app/pages/components/Button.vue?macro=true";
import { default as Layout8cnp2iwmPmvjVM_csGU1ZH9SyZgavLnrU34JH28zmEwMeta } from "/app/pages/components/Layout.vue?macro=true";
import { default as Select3FqUPaKG6Nm2jciGM4gDmGCvpOiq4yLfwCUzGcp66sAMeta } from "/app/pages/components/Select.vue?macro=true";
import { default as SwitchTonQwkFTShOLtz_L8wDaniKipQ4J3Neln1yn4SCaqVwMeta } from "/app/pages/components/Switch.vue?macro=true";
import { default as indexMW5kF9ynHm2eZ01T3ohkh9XOYOHTbuzTilXnJmP9tKUMeta } from "/app/pages/mobile/home/index.vue?macro=true";
import { default as ConfirmIWuFre_QD8Ggyv6oZGbDCgdP_InnOz3VAoOEGtSFrPQMeta } from "/app/pages/components/Confirm.vue?macro=true";
import { default as TooltipJQqUwG2Bey84fbFzqEFVb8eHoD_Yero3JQAkY91Et3MMeta } from "/app/pages/components/Tooltip.vue?macro=true";
import { default as CheckboxLvmFQxsF0ue1IIxMTUqk7yPWfhHXSppCCNdav4Y6th4Meta } from "/app/pages/components/Checkbox.vue?macro=true";
import { default as Textareaa2bKpmjcgiENuq2wc_45PD1_45oAwBijmQs3k_45J_LS_cpUQMeta } from "/app/pages/components/Textarea.vue?macro=true";
import { default as AccordionmWCPDTOrh__45pERTmUoGdV5Ps1WUlU1bP0Ztu_KP9um4Meta } from "/app/pages/components/Accordion.vue?macro=true";
import { default as UiSpinnerAw6xX7eOZMnUnQCQlXtDh75or4uTPlilvYLWdCa5ZrEMeta } from "/app/pages/components/UiSpinner.vue?macro=true";
import { default as indexlGlsh3TOD1thY_4cG0xBakv5AAN8oNSDW6u5362V2fQMeta } from "/app/pages/screens/logout/index.vue?macro=true";
import { default as DatePicker1EOeFB0bB_cTghpv3N3ANGw_45GODgvtkPFyiUNgwe8UkMeta } from "/app/pages/components/DatePicker.vue?macro=true";
import { default as EditUiTable9cQ87UAiL0AXm0pepLC_45QA0xR_45VrGeVQpiPJqYkXEGsMeta } from "/app/pages/components/EditUiTable.vue?macro=true";
import { default as TableDefaultqhSpJWr9JrqgPxu0VpuMVXUZllw8V226ZgWjNpnyejAMeta } from "/app/pages/components/TableDefault.vue?macro=true";
import { default as indexmDx2cS6VDDzuwjx60iPhIQ5SVzueWMdMM3dIwZEHWGsMeta } from "/app/pages/screens/dashboard/index.vue?macro=true";
import { default as indexgPd6dIjrhsIkBgtSR284Q422qzIxOhoyAIsg6APERCwMeta } from "/app/pages/screens/pa/member/index.vue?macro=true";
import { default as index_4591n0s9Apu4HB_45M1QTsx_45aaiFnpmdhRu1LVL9MQ_MoIMeta } from "/app/pages/screens/pa/report/index.vue?macro=true";
import { default as index4ZGHnC2BQY06L6MVW4sSgEaBky7b3ch7eCkgrhVmxhEMeta } from "/app/pages/screens/task/home/index.vue?macro=true";
import { default as MultiSelectorLFckEIC1MfrXe8DP7Qqbr6P9gMMC9Pc8g8sFc0U2v8gMeta } from "/app/pages/components/MultiSelector.vue?macro=true";
import { default as indexkVfNoa6lTWpO3W6ph063BZQaGncMMpZ7Bi_fxmR6kWsMeta } from "/app/pages/screens/pa/dataset/index.vue?macro=true";
import { default as indexTujcc7U5BxTM_45RVrY_45uWP1U0Vexj_lmgogHWdX_45qFvcMeta } from "/app/pages/screens/common/test/index.vue?macro=true";
import { default as modalyYAOAZebi6jIrGgfMRguIdW4HJcmtED5ud1VI6joOqgMeta } from "/app/pages/screens/common/modal/modal.vue?macro=true";
import { default as index4uiGEgaNvJe0sGEHyWCLKQV6au5X7wwu3c4v1QsbgNUMeta } from "/app/pages/screens/pa/dashboard/index.vue?macro=true";
import { default as auth_45required8jX05MXNaRI380HSmCJNdjeQ_2WN_4kjhvAExpQU4xEMeta } from "/app/pages/mobile/common/auth-required.vue?macro=true";
import { default as indexOVDSMgpUYBfUw_BM5Y5ISGuKKYdD27VRfU_458IV048W4Meta } from "/app/pages/screens/hr-mgt/carrer/index.vue?macro=true";
import { default as indexCRQeyCG_ExLgxwXer6RVE8YDeq78mKptW1pmkg_45O51gMeta } from "/app/pages/screens/task/handover/index.vue?macro=true";
import { default as index2EfKQ03yU3t26zsPRouVPESi2X3zmDDYk2uZiB4fftYMeta } from "/app/pages/mobile/eval/evaluation/index.vue?macro=true";
import { default as indexYqG3iRXjM8vIOcNNKFscFcHSr_JuIOK_Q9NDKVmv_o8Meta } from "/app/pages/mobile/password-change/index.vue?macro=true";
import { default as indexo_yr3Nkt4it8v8talPgakzPdQpbwkDMcYrJMjySzdMcMeta } from "/app/pages/screens/performance/idp/index.vue?macro=true";
import { default as indexdUW_CCUbOknlJBkyHy3bTmOF1LWSTPQQf_45VuWxgZM2wMeta } from "/app/pages/screens/performance/kpi/index.vue?macro=true";
import { default as index7s_UD5o60O9mU3jivGiv8He_3qakeuGZTX2eR1Pcm3oMeta } from "/app/pages/screens/performance/okr/index.vue?macro=true";
import { default as moduletu6JoMSAC410ZJuzjKFaZC69gQTgtAP3GsVla4Hun3AMeta } from "/app/pages/screens/dashboard/usage/module.vue?macro=true";
import { default as indexwcqBzaVxGyfn3kCagKq1pSPdMY2OKhBJuNPLbhmumk8Meta } from "/app/pages/screens/dashboard/manager/index.vue?macro=true";
import { default as generalYykEYOSTwa7oRZuSQXNDdyZ_453DZ_45ERGcBkt3mmexuKEMeta } from "/app/pages/screens/dashboard/usage/general.vue?macro=true";
import { default as index2oMRV68TmyYOiBCkf9jGhT5DQvfB8Neqq7P4CDHV_45_45QMeta } from "/app/pages/screens/hr-mgt/salary-mgt/index.vue?macro=true";
import { default as index9tm_45m1ja6_itSIQpNcxlkwWOwjCZpw9GiYqT_LGY_45X4Meta } from "/app/pages/screens/task/reports/view/index.vue?macro=true";
import { default as indexL18RjDHBqC_zt6G_45i59FKfAECQDQIXtOldjHHtk5KMUMeta } from "/app/pages/screens/dashboard/personal/index.vue?macro=true";
import { default as indexP4eZiz7llA4tDKTRm_Bf28IziUbNG_45TorFQg0n7tcbwMeta } from "/app/pages/screens/dashboard/timeline/index.vue?macro=true";
import { default as indexX7tXCz7HDmv2N8tZGLatdyvX_45eZJSGf6KU3X_vBSa3sMeta } from "/app/pages/screens/performance/status/index.vue?macro=true";
import { default as index8C4l11VXM4V5ijW1SYJb91vp6LXWllk7IpZxH8WysqwMeta } from "/app/pages/screens/project/my-project/index.vue?macro=true";
import { default as indextNWdv5UZ4QJMREbR5GYs3FxlHBZpYVuv7PLsXV2jilYMeta } from "/app/pages/screens/task/collaboration/index.vue?macro=true";
import { default as PageHeaderI4_45sJlQZpBWhA_45iwvmY7k8g2Mk6ymOE_fGBPoNZ8TfQMeta } from "/app/pages/screens/pa/member/comp/PageHeader.vue?macro=true";
import { default as PageHeader_65SAS9A0804StX42mlIn5Vzgz2ghSh4QPvn_45ZvnkykMeta } from "/app/pages/screens/pa/report/comp/PageHeader.vue?macro=true";
import { default as indexIU00r1sxPlXn_45sTne0Z2g6eMm333Umwk8nhq_ZoMdtAMeta } from "/app/pages/screens/task/reports/create/index.vue?macro=true";
import { default as index0Z1atb1Uuw8nwZLa2kes5D86YtB0bDuOyOoor74acgoMeta } from "/app/pages/screens/dashboard/performance/index.vue?macro=true";
import { default as indexf69ONnxgTjlTncEPB875WkvlwHsnWQ5NGHjjXy60gLoMeta } from "/app/pages/screens/dashboard/total-align/index.vue?macro=true";
import { default as indexxWWa_OljV2zfxgWX0LIFxZblXKq0FarPppsE9MATk1UMeta } from "/app/pages/mobile/eval/evaluation-results/index.vue?macro=true";
import { default as PageHeaderQdcfeegXb_45f_45JzJUHmcjxJ5avMW3Yh1UZ2nNAVu4aisMeta } from "/app/pages/screens/pa/dashboard/comp/PageHeader.vue?macro=true";
import { default as indexppJRcMQ2uVjFMx2V6R29h3cj_f9Q7PFNPijGJoQg9TUMeta } from "/app/pages/screens/project/project-config/index.vue?macro=true";
import { default as KPISectionxAgadLvBPvyYAB2m_45Ej0_45Lx0GLqMFtq4PoxO_45Y3WLkEMeta } from "/app/pages/screens/task/reports/comp/KPISection.vue?macro=true";
import { default as OKRSection2twH61jydfHDwg_jFyPhN16mXf2kprZRW2YCd8CBHecMeta } from "/app/pages/screens/task/reports/comp/OKRSection.vue?macro=true";
import { default as index3_IJWpyYfYBwzq8xrHDusYar26d5dT_UlkFOYKmgwTMMeta } from "/app/pages/screens/dashboard/hr-evaluation/index.vue?macro=true";
import { default as indexRofcXe8vZfazHj_Q5tj7KvPsv1JVck7ayKQOVIH00pcMeta } from "/app/pages/screens/hr-evaluation/diagnosis/index.vue?macro=true";
import { default as indexpHXFQiOV3XILmutx7cjrdDK2wi2wGxCPHu8dJ0kvUrYMeta } from "/app/pages/screens/org-evaluation/org-eval/index.vue?macro=true";
import { default as indexYzPb9hdBNv2luKCMImIIb8tzJ86_d3OFW_4561lraguVQMeta } from "/app/pages/screens/org-performance/org-kpi/index.vue?macro=true";
import { default as DonutChartCardPBWmN0hMTih3E2ia7FUhibto0KnCRsU11wKxbRMr9gsMeta } from "/app/pages/screens/pa/report/comp/DonutChartCard.vue?macro=true";
import { default as PredictionCardm8OhPp6alHcWKfPtUUylBzCWrD_45iYXULO1qZx098DqgMeta } from "/app/pages/screens/pa/report/comp/PredictionCard.vue?macro=true";
import { default as ReadStatusIndicatorbfhnEVMAQtNrNF2jWYE2pNtLIxKiSoCa0p6BfRpHa9gMeta } from "/app/pages/screens/task/comp/ReadStatusIndicator.vue?macro=true";
import { default as ReportsListxi8DrgRf_45uPnsd4kuqM5DQzgfPJLa9UVBjTeWkPiyXsMeta } from "/app/pages/screens/task/reports/comp/ReportsList.vue?macro=true";
import { default as index08zsnWyFUo_pM5IhykSqqk96_0JmJfn1Qqi6yZsWpqkMeta } from "/app/pages/screens/common/help-desk/support/index.vue?macro=true";
import { default as indexi4ZNdVLHlPQkt1Gmfrf10aOGHLdoS6rhjNVZqBqVGm0Meta } from "/app/pages/screens/hr-evaluation/adjustment/index.vue?macro=true";
import { default as indexGBUw7FXkgSMe11Hi858O2XhGJzZ5ksnapJUxwv45qi8Meta } from "/app/pages/screens/hr-evaluation/my-results/index.vue?macro=true";
import { default as indexd_45ItR6MLffGk_45vI9e4niM8up__45IjDSPgAB8sh6beEWMMeta } from "/app/pages/screens/hr-mgt/base-info/my-info/index.vue?macro=true";
import { default as indexT44tUn3PeqDUr7m35ST0r_BFZxvMYSE0opziiB4la0AMeta } from "/app/pages/screens/hr-mgt/base-info/org-mgt/index.vue?macro=true";
import { default as indexV5akRhQgXm2_45qDnpT7Ej_fFD_rce1XI2Zv1uDeDAVJ8Meta } from "/app/pages/screens/onboarding/support-board/index.vue?macro=true";
import { default as indexwiTxSUHk168qfmMQqDdwE5CH43RVDXc9A3DS8MHx_45iMMeta } from "/app/pages/screens/common/config/code-config/index.vue?macro=true";
import { default as indexCQkdtbkrUQ_45pK_45jW3AG_I1q8NNciQju6w2W100ytvMEMeta } from "/app/pages/screens/common/config/task-config/index.vue?macro=true";
import { default as index8WNBp8MUA4iIPGzMxTjRovxC4qPdKWuXwQwbsvxLhnAMeta } from "/app/pages/screens/hr-mgt/base-info/user-mgt/index.vue?macro=true";
import { default as index6k1tSBsqPjSs4JgFkVK_45RXCNMCDAiOEhvzOWn2hhawUMeta } from "/app/pages/screens/onboarding/welcomb-aboard/index.vue?macro=true";
import { default as ChartDetailModalEj_45__45hMoAq_455699PLY8QCjyhPBoBnty2PFhXizERnR8Meta } from "/app/pages/screens/pa/report/comp/ChartDetailModal.vue?macro=true";
import { default as DonutChartuHTvUNMr6gVBuAzeXuKbPcbIunn4PZanpAX4YLCpw_45kMeta } from "/app/pages/screens/performance/kpi/comp/DonutChart.vue?macro=true";
import { default as PageHeadersm5mxxLtKCmlLugFst3FWZYVuWCkCPbNl7XeAo6BHf8Meta } from "/app/pages/screens/performance/kpi/comp/PageHeader.vue?macro=true";
import { default as indexY3I7U8zXzi9xoB5N_45D4tA8tEF9gY2jyuKHABLranfJkMeta } from "/app/pages/screens/project/standard-template/index.vue?macro=true";
import { default as ReportsDetailnGq7yOwPbNFSYlxIHeZQs9HfNhZdN_v3Cky4VjQgl8MMeta } from "/app/pages/screens/task/reports/comp/ReportsDetail.vue?macro=true";
import { default as ReportsHeadergjYOLRs3al87oZ6q2Qy2SfQGCGP3Q3DHAMtbkjaPXjoMeta } from "/app/pages/screens/task/reports/comp/ReportsHeader.vue?macro=true";
import { default as indexNsdxlTyjnsFJd_X5cGUOKQLb8wlERRjcpWXkRpouVrQMeta } from "/app/pages/screens/hr-evaluation/conf/targets/index.vue?macro=true";
import { default as MonthlyTrendChartbm8cqvArGNbv4c3zJXnJuZpJp0o9KsgL1_45WMXrsH3FcMeta } from "/app/pages/screens/pa/report/comp/MonthlyTrendChart.vue?macro=true";
import { default as DetailPanelj7_459GhRXyqd_J68NI8OPmP4zB9CHNcR_O6xvg5ru0qoMeta } from "/app/pages/screens/performance/kpi/comp/DetailPanel.vue?macro=true";
import { default as MemberPanelP7Bq0F6aE_45mikFs2PV2Bu3d64IOUAloZAGnUB1CGR_45gMeta } from "/app/pages/screens/performance/kpi/comp/MemberPanel.vue?macro=true";
import { default as CollaborationChatW94SDuUzQjf_lsJKj0W7Gp7pznpwUpn2HdKWsO6lP1AMeta } from "/app/pages/screens/task/home/comp/CollaborationChat.vue?macro=true";
import { default as CollaborationFeedgxvR7QsuBAkxTPysPr_qEMIdzRocOkm0ML8l6yl5esIMeta } from "/app/pages/screens/task/home/comp/CollaborationFeed.vue?macro=true";
import { default as CollaborationItem4uphcTYivsEY6ALTLOGNswhgAcqf0VsoSXs9zO8dN44Meta } from "/app/pages/screens/task/home/comp/CollaborationItem.vue?macro=true";
import { default as ProjectSectionyt5BUfTw2QHbYDrpIE3oadxgdObdl76ytJsVKCwK97EMeta } from "/app/pages/screens/task/reports/comp/ProjectSection.vue?macro=true";
import { default as indexNDq_zBUIMaUVy3dFstoSeVhfpsrrTAZhIQwWkUrU1VkMeta } from "/app/pages/screens/hr-evaluation/conf/settings/index.vue?macro=true";
import { default as indextF6QMhl9kqE80FArntLQULBIMX2_45nZNI1fF905tMofgMeta } from "/app/pages/screens/performance/job-description/index.vue?macro=true";
import { default as index6uKMj7eiSLtp7RuSXtZmu5BJuVEyLBOe4rgeDDYzLqsMeta } from "/app/pages/screens/performance/kpiDetailStatus/index.vue?macro=true";
import { default as indexSlAh_eU6tglaLtRWcQGMLaOBB6z6aSGjfFO_457ZldOm4Meta } from "/app/pages/screens/performance/okrDetailStatus/index.vue?macro=true";
import { default as FeedbackCommentlM_7r05TlvrAhXpfylf3Vc_45BTogQETV6OwsCruoKdeEMeta } from "/app/pages/screens/task/reports/comp/FeedbackComment.vue?macro=true";
import { default as indexFyhkHjccAmVj7aINg1rQMrU_nET9_459_45lXHE3ShkFogUMeta } from "/app/pages/screens/hr-evaluation/results/report/index.vue?macro=true";
import { default as YearlyTrendChartXG9oFT7kL_45sXOzFMvfYTa7ah056jQ8c1vQ9s5wjGh_0Meta } from "/app/pages/screens/pa/dashboard/comp/YearlyTrendChart.vue?macro=true";
import { default as DatasetDetailModaldhEzmFWOOKJ8tFVNPgJXcJA5QZVG_45WTryXxWmFLyihYMeta } from "/app/pages/screens/pa/dataset/comp/DatasetDetailModal.vue?macro=true";
import { default as KpiFormFields1UG0jy9_45lvR2u2VW3HKeGIwk9SFM8aVsUsMt29bSaMAMeta } from "/app/pages/screens/performance/kpi/comp/KpiFormFields.vue?macro=true";
import { default as KpiTermNoticeI2NNNyAUZKX_452_45jyzEseL2JFpPsenbs7QyO241KopEcMeta } from "/app/pages/screens/performance/kpi/comp/KpiTermNotice.vue?macro=true";
import { default as OkrFormFieldsQrWvgIWg0TpRcxGi0lfXUlvb0ypEZGuhHNhAFN1IZ3sMeta } from "/app/pages/screens/performance/kpi/comp/OkrFormFields.vue?macro=true";
import { default as PageHeader_45wcMNZI2ZfgBqTtNWpWpeg7bh46shGGC3VfgkexPgt8Meta } from "/app/pages/screens/performance/status/comp/PageHeader.vue?macro=true";
import { default as CollaborationHeaderurHCIj2kD_457YwUDmhxXUsZ45T_Yr8OnfUhkS8R013ngMeta } from "/app/pages/screens/task/home/comp/CollaborationHeader.vue?macro=true";
import { default as indexnTIS0RVzAAsew3ju_4571sfnRYK69XugrNvA_45e0R8UBFoMeta } from "/app/pages/screens/common/config/ai-token-config/index.vue?macro=true";
import { default as MonthlyTrendChartqRE3p7YOOZAaXghzgX2cZ27QgCsJK3xGd4vqmujk93EMeta } from "/app/pages/screens/pa/dashboard/comp/MonthlyTrendChart.vue?macro=true";
import { default as OrganizationTable0FOXSTlscIuig4_45ql5QjqfVlkEMxIVetUzh6RNkEPmcMeta } from "/app/pages/screens/pa/dashboard/comp/OrganizationTable.vue?macro=true";
import { default as CollaborationSidebaron_vYLKhfbVyhXZ4arAuFbI9Vf8nzuR1BQwy6enVedIMeta } from "/app/pages/screens/task/home/comp/CollaborationSidebar.vue?macro=true";
import { default as indexoj_vlEvWTgFsZeqwiyZuvqbrSM22h7on2_KfpiL22ScMeta } from "/app/pages/screens/common/config/comp-info-config/index.vue?macro=true";
import { default as indexhLSZrwGcyZKCiNs58oe2Lk_45x3J8TgxBgkOa3_45BbRbhEMeta } from "/app/pages/screens/hr-evaluation/evaluate/ability/index.vue?macro=true";
import { default as indexyy490YmFV1I_3SrSR1CHo9MuzO_458FQvR0d7qIom3Xy0Meta } from "/app/pages/screens/hr-evaluation/evaluate/perform/index.vue?macro=true";
import { default as index2NnDGCOGUS0FKbHzqzLogXMfZxykckTK9uwSdQuPOzcMeta } from "/app/pages/screens/hr-evaluation/progress/targets/index.vue?macro=true";
import { default as index6RXDNsOIWx_45kCWbVBgsu4yKMEp1Z5U210Yit3ZyFS_gMeta } from "/app/pages/screens/hr-evaluation/results/row-data/index.vue?macro=true";
import { default as indexpUBU9G14TzrfyzN5PlfpsBW3MfNajC9v5vNaYAQEFsYMeta } from "/app/pages/screens/hr-mgt/hr-monitoring/user-tree/index.vue?macro=true";
import { default as indexi9Regnh1BQxVd9j6Fnh_45xdTPHJKDMQTmVsHSJxN5xZwMeta } from "/app/pages/screens/org-evaluation/org-eval-adjust/index.vue?macro=true";
import { default as indexKihE0KziUThw_7MNtzDiNLFU2XaT4dx2GBhbJOssUDAMeta } from "/app/pages/screens/org-evaluation/org-eval-result/index.vue?macro=true";
import { default as indexlMePBM4DVLKW_IjHA0ZV1Jy_45fZknTMga0f990LzByzoMeta } from "/app/pages/screens/org-performance/org-kpi-actual/index.vue?macro=true";
import { default as PlanStatusLabelcIiuuOhkbDvhs0bvu10L3Ck7f7NtoECAnyg91C77fZgMeta } from "/app/pages/screens/performance/kpi/comp/PlanStatusLabel.vue?macro=true";
import { default as ReportModalLSnbgscQu8TZOsjlbqJ17z1C7yrQ0sz1SRYkAbEFgj8Meta } from "/app/pages/screens/task/reports/comp/modals/ReportModal.vue?macro=true";
import { default as PlanContentSectionDoRHQQFEHeNEepKKOM06M1SsCVk4mKKezgYmNf09tO4Meta } from "/app/pages/screens/task/reports/comp/PlanContentSection.vue?macro=true";
import { default as indexcIV10mqrPAzl3qF522K3pa4xDyLAg_IeQiXXiu0Q2hwMeta } from "/app/pages/screens/hr-evaluation/objections/review/index.vue?macro=true";
import { default as indexUyjBYWWtXVgIZfH72feNqR4ZH38trzLzRL6uzl34APQMeta } from "/app/pages/screens/hr-evaluation/objections/setting/index.vue?macro=true";
import { default as indexyPDXg9kNDEfSszxMB3RjPDdjgpTrlj5Z32IngBajFRoMeta } from "/app/pages/screens/hr-mgt/hr-monitoring/user-detail/index.vue?macro=true";
import { default as indexLaOFxmmw5wy8ecJTzN1UYKUz_xmS5FV7eWvU_45AU0mB4Meta } from "/app/pages/screens/onboarding/onboarding-config/faq/index.vue?macro=true";
import { default as index7xSbuadNXnrJwBuIgA_zcs0C236POldY9YL4ClXHwpoMeta } from "/app/pages/screens/org-evaluation/org-eval-etc-item/index.vue?macro=true";
import { default as ActualContentSection_458fMfzSA5fa0s3Ee1Y5rPKMYcYGJIPXjBEVDPJuNdPcMeta } from "/app/pages/screens/task/reports/comp/ActualContentSection.vue?macro=true";
import { default as indexlg3TefY_NgZblD45XoD93SE6_45i8jVmtdHqCTMbyEzP0Meta } from "/app/pages/mobile/eval/evaluation-results/objections/index.vue?macro=true";
import { default as indexRxP6s1UfLkoyf4a8EzZ_p1D_45dzTTJE7WKtVAEKV1jagMeta } from "/app/pages/screens/common/community/notice-board/qna/index.vue?macro=true";
import { default as indexSTwys7_45hsuMREiEUmb7HiaRGUsZ75Oo540QkXkhKfbkMeta } from "/app/pages/screens/hr-evaluation/calculation/ability/index.vue?macro=true";
import { default as indexL7JSShh1W4HA0LF758Bj60l9CQaaiDbcanZBzVBJstgMeta } from "/app/pages/screens/hr-evaluation/calculation/perform/index.vue?macro=true";
import { default as indexbYkq2QyKxPtG93LDAkjyaABS_45Ne5vCFGV6bniV35IpwMeta } from "/app/pages/screens/hr-evaluation/progress/evaluators/index.vue?macro=true";
import { default as indexCSFmCPVUN1p7KwLr0lORvOKbpCA7_45hVUO4VMZqkM43YMeta } from "/app/pages/screens/onboarding/onboarding-base-config/index.vue?macro=true";
import { default as AllMemberDatasetModalm4mq_45HBEqGyXAQ0OO4txXb9RVd_W6BL8Sr4ZoKiPqoQMeta } from "/app/pages/screens/pa/dashboard/comp/AllMemberDatasetModal.vue?macro=true";
import { default as KpiCopyMenuovaucqnNXM7PN6q0KdAqlme_45J7FTYzaLx9xXLPnE5gYMeta } from "/app/pages/screens/performance/kpi/comp/modals/KpiCopyMenu.vue?macro=true";
import { default as KrLinkModaldqHjcOIOz6aN8C7zKpcBHUVEx2rsue4jPULTIeyVGlgMeta } from "/app/pages/screens/performance/kpi/comp/modals/KrLinkModal.vue?macro=true";
import { default as AiSummaryModalFMrQdPN10m99Ik4ptxq_45yMK_7cPNg10eRsQhQbSSmfQMeta } from "/app/pages/screens/task/reports/comp/modals/AiSummaryModal.vue?macro=true";
import { default as PmsDetailModalXTCwii2C6UrwX97H7ri7_rstn81dFr6bvhli_7mEe30Meta } from "/app/pages/screens/task/reports/comp/modals/PmsDetailModal.vue?macro=true";
import { default as ReportOkrModalRBYQOzdUIx8f1x_45pO5BsD3E0uKypCpLrk9DtLY_45PKgQMeta } from "/app/pages/screens/task/reports/comp/modals/ReportOkrModal.vue?macro=true";
import { default as submitrdW8UuuyiHvwiptSZnMUpPY12PKqWbrJNHcyHbhCJqAMeta } from "/app/pages/mobile/eval/evaluation-results/objections/submit.vue?macro=true";
import { default as PageHeaderojzQyaptxVpreRnBPiGptVfDryAFBJ9lzl2Axfa_nTcMeta } from "/app/pages/screens/hr-evaluation/adjustment/comp/PageHeader.vue?macro=true";
import { default as PageHeaderoXclZDKZ9YKr_syLjcbSpN3l33RE3K5lAtTn08Vm3qMMeta } from "/app/pages/screens/hr-evaluation/evaluate/common/PageHeader.vue?macro=true";
import { default as indexwyULGFPbKTsU1XKIHL4dgspl1y_450B7X_45yh5_MrQASpEMeta } from "/app/pages/screens/onboarding/onboarding-config/goods/index.vue?macro=true";
import { default as indexnt1UX9TbY2dWnD5DRvz4JgggWiJWTMBxFv7EpobAqKkMeta } from "/app/pages/screens/org-evaluation/org-eval-monitoring/index.vue?macro=true";
import { default as indexeXPgyLc7AsswHPMpKk7iucbw6c3uow9npdz1_tY3ZOkMeta } from "/app/pages/screens/org-performance/org-kpi-monitoring/index.vue?macro=true";
import { default as MemberPerformanceChart_45Y7XBs_QJg1_45rgqBv1tUasyUzzWGC7jl8BeEDsUfeuoMeta } from "/app/pages/screens/pa/dashboard/comp/MemberPerformanceChart.vue?macro=true";
import { default as MemberPerformanceModalmHhSmp6GkOVoRIvq_ngSVt_j974woWB_45mTiWZkwARbAMeta } from "/app/pages/screens/pa/dashboard/comp/MemberPerformanceModal.vue?macro=true";
import { default as KpiActualTabContent0qEA1PL3vOJRMJHW51KiO8AO9Hwuilfs4AgLQMj3TLUMeta } from "/app/pages/screens/performance/kpi/comp/KpiActualTabContent.vue?macro=true";
import { default as FeedbackCardWWjwf1bkJtqY2RK6OF2sncGyu2gYywJ8PZR_1Akg1S4Meta } from "/app/pages/screens/performance/kpi/comp/modals/FeedbackCard.vue?macro=true";
import { default as KpiLinkModalxrRuHuJCV_GieZ3mYyHZKcKKnB5g7qQ35VXDEtk_45BzAMeta } from "/app/pages/screens/performance/kpi/comp/modals/KpiLinkModal.vue?macro=true";
import { default as indexuJ2uRwbvOI_45AVvcs5MJGcXtFDbWMsAhFsz9rAwLijGkMeta } from "/app/pages/screens/common/community/notice-board/board/index.vue?macro=true";
import { default as index_au2RsUiwZ7F8ZdPN5u0XtFeAjbEJr0Q5BtwizrGL2MMeta } from "/app/pages/screens/org-evaluation/org-eval-calculation/index.vue?macro=true";
import { default as FeedbackModal39kwIxUBarXHWUBDR__45TQ1DX2dMF4KrIWzF4MJTXwOYMeta } from "/app/pages/screens/performance/kpi/comp/modals/FeedbackModal.vue?macro=true";
import { default as KrDetailModal52HNIR0SrXi9I8QRTLB2yWLCQ6K4pCj_5sB5H6YASgIMeta } from "/app/pages/screens/performance/kpi/comp/modals/KrDetailModal.vue?macro=true";
import { default as PerformanceGoalTablety_45u2AVn_45CeY0TdMefu5LMWWVAXA4vQiyUQRQJKvu9EMeta } from "/app/pages/screens/performance/kpi/comp/PerformanceGoalTable.vue?macro=true";
import { default as AiSummaryConfirmMessagefJz43pFj_45YV8jBnPjAApMfnuZuoxyVCxxrP6HLAbsYwMeta } from "/app/pages/screens/task/reports/comp/AiSummaryConfirmMessage.vue?macro=true";
import { default as ActivityAddModal_xY30z3eE_QWkO_pCwXuUvHD2V_45a3bxAiWBnv_45iclMgMeta } from "/app/pages/screens/task/reports/comp/modals/ActivityAddModal.vue?macro=true";
import { default as indexqhFx9bmuFITGGQfk7as0okHgEX0ddDVyTQzk2_45bDjw8Meta } from "/app/pages/screens/common/community/notice-board/notice/index.vue?macro=true";
import { default as indexkslq9wAoNX__sI_45FXVCvvcJ5H_45u_QpDMZhilegbuXY8Meta } from "/app/pages/screens/common/config/org-performnace-config/index.vue?macro=true";
import { default as indexz4hyifCKHUjHL0bc3Qnmu09qzv8iMwODMEe8BPZKx5AMeta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-scale/index.vue?macro=true";
import { default as PageHeaderRH0OZgv_yrMtK1oLGvFTPJ1jFImMXWjWvChX8kRn5J4Meta } from "/app/pages/screens/hr-evaluation/conf/targets/comp/PageHeader.vue?macro=true";
import { default as SearchFiltertUmV6sZHr4JjsMrn_45VumoB_45zm4ElmWusgem_KkTR5uMMeta } from "/app/pages/screens/hr-evaluation/evaluate/common/SearchFilter.vue?macro=true";
import { default as _91gbnCd_936Lf8efH81tTPkyPVFHtL06EfxX1vWOjOskTuqVTTHT4Meta } from "/app/pages/screens/hr-evaluation/results/results-view/[gbnCd].vue?macro=true";
import { default as indexotfCtfQX6AV_JLLJYsgkcKM_454gT6CYyQPbO_sMVaKigMeta } from "/app/pages/screens/org-evaluation/org-evaluation-config/index.vue?macro=true";
import { default as KpiPropertyTabContentATFLje9OjPiv0LqMKU4Kop1TwcqyWrKugsXd4C_Cr9gMeta } from "/app/pages/screens/performance/kpi/comp/KpiPropertyTabContent.vue?macro=true";
import { default as ActualAddModalt2MQJ330GizVj0U_45UAEPwQTmHTgA06IjEqijer0CXJQMeta } from "/app/pages/screens/performance/kpi/comp/modals/ActualAddModal.vue?macro=true";
import { default as KrCopyMoveMenumvMES8WvRKuqZ2OISsHpiO4NLHE905CQjUSnEOFivq4Meta } from "/app/pages/screens/performance/kpi/comp/modals/KrCopyMoveMenu.vue?macro=true";
import { default as OkrSelectModalDL31BeSl0eXuxfr_e6sjBTFikAyL9rIQrK5aa5Z_rpoMeta } from "/app/pages/screens/performance/kpi/comp/modals/OkrSelectModal.vue?macro=true";
import { default as ReportConfigModal_t_45rwWHiaXuWVbjh1TVZrzcHKyMZVDZpnx8x4Gpd2LEMeta } from "/app/pages/screens/task/reports/comp/modals/ReportConfigModal.vue?macro=true";
import { default as PageHeaderRxU6_45yTmdhPKOv0sIeTdCK3HjddtbVbLZSB_deyLkD8Meta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/PageHeader.vue?macro=true";
import { default as indexMTAOg5kPxClSzqWgmLaPRNG06nkoSkmR__Q5_45nuszogMeta } from "/app/pages/screens/onboarding/onboarding-config/schedule/index.vue?macro=true";
import { default as KpiSettingModal_45TVVv0c5gF5qqIOFbKnk0_da19BqzDMwxzuEAnLCKZUMeta } from "/app/pages/screens/performance/kpi/comp/modals/KpiSettingModal.vue?macro=true";
import { default as KrCascadingNode_v3u3ZhsgvD_H3EnLwR92eWwwkbtz3nqR56QdXCRurIMeta } from "/app/pages/screens/performance/kpi/comp/modals/KrCascadingNode.vue?macro=true";
import { default as KrCascadingTreexVcl3p80WaNrdLoa739d_baglafCy_E1tody3MmlUiMMeta } from "/app/pages/screens/performance/kpi/comp/modals/KrCascadingTree.vue?macro=true";
import { default as PageHeaderb3adoHd8B_45iLEMNQnJj3LqpqTo_45i46uQaV9_thvFmN4Meta } from "/app/pages/screens/performance/kpiDetailStatus/comp/PageHeader.vue?macro=true";
import { default as PageHeaderVUg4mSnKGnSNnqmWsXqD7i6osKVynciBJqq_45KQeiltgMeta } from "/app/pages/screens/performance/okrDetailStatus/comp/PageHeader.vue?macro=true";
import { default as index22fG5JF3T0E_2U3sM2Ke1eE6NfGqsotaqfxR55iFPiwMeta } from "/app/pages/screens/common/community/notice-board/bulletin/index.vue?macro=true";
import { default as ManagerIdpPaneld9sbOSWg_yYROIoxRd26eWSN_mzAfUV4NhpjWXVRHjAMeta } from "/app/pages/screens/dashboard/manager/components/ManagerIdpPanel.vue?macro=true";
import { default as ManagerKpiPanelXZQrDMzTyXAQRkFNoDKG9U9bjEDS_45bCTIFsvcuP49sUMeta } from "/app/pages/screens/dashboard/manager/components/ManagerKpiPanel.vue?macro=true";
import { default as ManagerPlanListSInWIXYxwruSGefjgp6g5FwUrIjTWOD1UG2elQcpYKYMeta } from "/app/pages/screens/dashboard/manager/components/ManagerPlanList.vue?macro=true";
import { default as EmployeeCard52D9mHpv6O9U3QkxvAGos4LlfjW528hTIbfDKqmZC_45QMeta } from "/app/pages/screens/hr-evaluation/conf/targets/comp/EmployeeCard.vue?macro=true";
import { default as indexUM5ZewH3gFEpCASIrGU2P0Zbkjk32jfUpVz5cofbi44Meta } from "/app/pages/screens/hr-evaluation/description/job-template/index.vue?macro=true";
import { default as EvalTargetListZGfZxbkyqo4_45NOWvNORa3m2_45hFXVfGHa0T7sbTRNhyIMeta } from "/app/pages/screens/hr-evaluation/evaluate/common/EvalTargetList.vue?macro=true";
import { default as PageHeader1xGECEmVIHoUUjkKWtOaG9h86MHOxWVNBHIYA6qoI0IMeta } from "/app/pages/screens/hr-evaluation/results/report/comp/PageHeader.vue?macro=true";
import { default as CollaborationTaskModaloO9rG1bCe1gHTcFgbtCrh0wGJvUOx3kjZ9X2j3WAJ9EMeta } from "/app/pages/screens/task/home/comp/modals/CollaborationTaskModal.vue?macro=true";
import { default as ActivityContentCellaFSZEkGjYZ8X3uAwFB_45gN_45ZzoZQInHzi0oByNgLl99sMeta } from "/app/pages/screens/task/reports/comp/modals/ActivityContentCell.vue?macro=true";
import { default as ManagerPlanPanelhzfZyOqQ41rYZkL9JPMrfpyU8p_45oy14xUs3B4_WT85AMeta } from "/app/pages/screens/dashboard/manager/components/ManagerPlanPanel.vue?macro=true";
import { default as _91objectionId_93j1K9_450mEx7lLwFICMhEyiyO_BHWCbyUtB_qEXomDn9UMeta } from "/app/pages/screens/hr-evaluation/objections/review/[objectionId].vue?macro=true";
import { default as indexaqjsdRsS7iXUFisk6ZKpexWPcOSNRPWNMPC_45BAmKKe4Meta } from "/app/pages/screens/hr-evaluation/results/total-result-view/index.vue?macro=true";
import { default as indexHL3qXv6RjkjPgDl9NTkOX0EhK8fHyN842a7zMhwPiTAMeta } from "/app/pages/screens/onboarding/onboarding-config/advertiese/index.vue?macro=true";
import { default as OrganizationComparisonChart_YyB6Qyqar9E9PS4jyvxzw536LbO7j_FWzXh_45VWDgAIMeta } from "/app/pages/screens/pa/dashboard/comp/OrganizationComparisonChart.vue?macro=true";
import { default as AiSummaryEditorBlockb0u25kJIxVZ8ATi_453Zj_45DOTvHGmfYP1UOGNJ7QAIckcMeta } from "/app/pages/screens/task/reports/comp/modals/AiSummaryEditorBlock.vue?macro=true";
import { default as ManagerGanttChart_45jzYLFg96BiGeYONuXA3i4lar8cZj_CL1kEgNklqr7kMeta } from "/app/pages/screens/dashboard/manager/components/ManagerGanttChart.vue?macro=true";
import { default as evalTargetListwE1_451IXXBBrXy086ol9RTM9tQG2piKq6wAYeZLUShJoMeta } from "/app/pages/screens/hr-evaluation/conf/targets/comp/evalTargetList.vue?macro=true";
import { default as EvaluationResultRMg5jlcZxX5XcVLk4ctCAS6Wf278NKR9SyWwzCodbngMeta } from "/app/pages/screens/hr-evaluation/my-results/comp/EvaluationResult.vue?macro=true";
import { default as DistributeKpiModalCyybQEsxQ9u8HdqBOhtcf8AyW2qtdWgwnC_l2kf0Ap8Meta } from "/app/pages/screens/performance/kpi/comp/modals/DistributeKpiModal.vue?macro=true";
import { default as ManagerActivityRowsa6HBOUz5QsnSaMIDvvaaUKn75vlUNUB4MVOdBuJDC4Meta } from "/app/pages/screens/dashboard/manager/components/ManagerActivityRow.vue?macro=true";
import { default as ManagerHrEvalPanelaJCeDjG7_45qF0VRhcMKVDYjk1PX8WziniZTfBM8xO2JQMeta } from "/app/pages/screens/dashboard/manager/components/ManagerHrEvalPanel.vue?macro=true";
import { default as ManagerOrgTreeItem8MqN_7_vkLCDzpqgBx_45A_bR4zpU_45EHLir6Ulr8P_45YNcMeta } from "/app/pages/screens/dashboard/manager/components/ManagerOrgTreeItem.vue?macro=true";
import { default as PersonalPerfPanelgIM3w6CpmUHQiUFK_9HY1BCI3SiB51FN3ftouZMFYsEMeta } from "/app/pages/screens/dashboard/personal/components/PersonalPerfPanel.vue?macro=true";
import { default as PersonalWorkPanelbiVSjTsdOCGTUuipm_45CbCaf1C4IkmfRT1Pub3Ze_bHsMeta } from "/app/pages/screens/dashboard/personal/components/PersonalWorkPanel.vue?macro=true";
import { default as index4MRka6BhugwCAyjFsGE_n_2ufoso7_DVQviKERt5NRMMeta } from "/app/pages/screens/hr-evaluation/calculation/org-calculation/index.vue?macro=true";
import { default as indexcfHyHNeF1uYsKwaLSoEVFJ0R_45Y5aiG7WaiwZ7VlQfh0Meta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-items/index.vue?macro=true";
import { default as indexFmfdy00U_18WEIU54YE6HiG8yTSwFXa0uCdbsomFK6YMeta } from "/app/pages/screens/hr-evaluation/description/job-description/index.vue?macro=true";
import { default as indexYPuXD_45ZeqqpgFJTC0XA146PX3VN7gR6uPutCf1hRfVQMeta } from "/app/pages/screens/onboarding/onboarding-config/welcome-mail/index.vue?macro=true";
import { default as indexZrisRCuSB18Fn5ysliXZGAWUdrTpYbuVggQTmMq8__4Meta } from "/app/pages/screens/project/monitoring/all-project-monitoring/index.vue?macro=true";
import { default as ReportKpiReadonlyModal_45z49FSPjZygNo7yNvuwrEE0KexshOoINJXy9cMqtXysMeta } from "/app/pages/screens/task/reports/comp/modals/ReportKpiReadonlyModal.vue?macro=true";
import { default as indexe0US_VbAf9G0jvBovhrcF8u2_45u6F0iZUVOn9KH7VptEMeta } from "/app/pages/screens/common/config/auth-config/menu-auth-config/index.vue?macro=true";
import { default as index_45AHP5lh18BLJrEjmmwT0781sUqLStvB4QAKQsQyCFhYMeta } from "/app/pages/screens/common/config/auth-config/user-auth-config/index.vue?macro=true";
import { default as ManagerJobDescPanelgtqeD7P02s_45FEUeuDP2FqkChXYoy7UY3cjXqRIYL_6wMeta } from "/app/pages/screens/dashboard/manager/components/ManagerJobDescPanel.vue?macro=true";
import { default as ManagerOrgTreePanelSQP98I3_45W1eD5wtHJgOd3XFKkRMnAAEM2K_45tBbZMAuAMeta } from "/app/pages/screens/dashboard/manager/components/ManagerOrgTreePanel.vue?macro=true";
import { default as indexAbhBa0hXeeXFzSVcULVaza0gbh41a2_R7PW8sGqsBeAMeta } from "/app/pages/screens/hr-evaluation/conf/basis/performance-items/index.vue?macro=true";
import { default as InsaWizardModal1gLQY9aV4hKDLInDNvrkXdYUVUZ8cS1EafnInO_D1UEMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/InsaWizardModal.vue?macro=true";
import { default as evalTargetDetail_4ErK0lRJW2BefcE_qeV1wWLP7qeDYvG6JeDrZ0zsj4Meta } from "/app/pages/screens/hr-evaluation/conf/targets/comp/evalTargetDetail.vue?macro=true";
import { default as GuideModalhncCvkjUr4u0IWIumz_Wfas67z48Kom1JIQ0njA26tUMeta } from "/app/pages/screens/hr-evaluation/conf/targets/comp/modal/GuideModal.vue?macro=true";
import { default as indexCLl0lt6kbJroRsaYQpqBmkYgzWnK_45_455l6Hr_45NkFxfZ4Meta } from "/app/pages/screens/onboarding/onboarding-config/feedback-item/index.vue?macro=true";
import { default as AgreementReasonModalra1tCPnXl1NfsXxCQ8JKK_NycKMlDzM4NqoczHBXuyQMeta } from "/app/pages/screens/performance/kpi/comp/modals/AgreementReasonModal.vue?macro=true";
import { default as indexU9NsEQNlhq9iZ7PkCEWNHoGnkKqW_uO9kNKOqVcODqQMeta } from "/app/pages/screens/project/monitoring/dept-project-monitoring/index.vue?macro=true";
import { default as ManagerActivityPanel532Sat5fOor6Gw1TuFmlXdEROhL3TIglfl06_n5cltYMeta } from "/app/pages/screens/dashboard/manager/components/ManagerActivityPanel.vue?macro=true";
import { default as ManagerCalendarPanelFW7YOvWcoWFo5G8dU2Wv9J5veEuv8jHY1aOdl0GoWg4Meta } from "/app/pages/screens/dashboard/manager/components/ManagerCalendarPanel.vue?macro=true";
import { default as ManagerPerfStmtPanelrd5mH_45KpMQjRt5BhVnjzL4sfNxVtOb_45VE77XLg18P6wMeta } from "/app/pages/screens/dashboard/manager/components/ManagerPerfStmtPanel.vue?macro=true";
import { default as ManagerPlanFilterBar90mx14TjzpS_45FrkjRGm5FlBpsxF709f7DgKKe7Ke44cMeta } from "/app/pages/screens/dashboard/manager/components/ManagerPlanFilterBar.vue?macro=true";
import { default as ManagerTimelineModal_45ZLWOkhDJscjczPp2qhp1Yqx9SNUkHeCQlUkpSsBMQIMeta } from "/app/pages/screens/dashboard/manager/components/ManagerTimelineModal.vue?macro=true";
import { default as ManagerTimelinePanelMkbcfy2jyOs8ohUxKpI8STiQsgeWjYzzvyWz2uXu5vsMeta } from "/app/pages/screens/dashboard/manager/components/ManagerTimelinePanel.vue?macro=true";
import { default as indexcUoxU7GdjVVPdCj1GMoXDFixDJ_45t73Wiac9m_45u1WfFAMeta } from "/app/pages/screens/hr-evaluation/calculation/total/other-items/index.vue?macro=true";
import { default as indexSbLESWJHFNkhr6pPRsX8uCe9yXsZ_45kpiSLwr2ML14MsMeta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/index.vue?macro=true";
import { default as AiHelperButtonrRgunKAHWe478d_nP9lnlU5cLh2dupxLoK9JEdjQiE0Meta } from "/app/pages/screens/hr-evaluation/evaluate/common/comp/AiHelperButton.vue?macro=true";
import { default as ResultEvalTabV2tOSUAUvoqX6eYvDDHzLX2qQMHang3elgzBjz_8VIYMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/ResultEvalTab.vue?macro=true";
import { default as AgreementContentModalNxfw09XSsAkJ3QKpJEWGRPtzwK4i_45dp_45wXWEyflL2AUMeta } from "/app/pages/screens/performance/kpi/comp/modals/AgreementContentModal.vue?macro=true";
import { default as AgreementHistoryModalCUbN12N5FI6oMx_45ahLkmZnn6I4CeQKMw1B3wjRMfiroMeta } from "/app/pages/screens/performance/kpi/comp/modals/AgreementHistoryModal.vue?macro=true";
import { default as indexTnHx69BmQjzI1Mdrr_j_ubbTrIsydmukBGUgy5ye8j4Meta } from "/app/pages/screens/project/monitoring/issue-project-monitoring/index.vue?macro=true";
import { default as ManagerHrEvalTreeItemoqpLlmwLkUF5OE7bGKoMEWYU3fV2NxEkYHkmfsTD958Meta } from "/app/pages/screens/dashboard/manager/components/ManagerHrEvalTreeItem.vue?macro=true";
import { default as LoadSettingsModalgUnMu4k46oh5O24hVw_f5jNTB2Eu8zWLYpiVR8C_v88Meta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/LoadSettingsModal.vue?macro=true";
import { default as indexuwQLbo4XaW9NXMGU8aIDQ0ML7vfesdOVNlSTiBNqnKEMeta } from "/app/pages/screens/hr-evaluation/description/description-status/index.vue?macro=true";
import { default as PrevEvalResultNUEcqVlRf4jif5lhK9Y8Jb84a7TcS2SZtQuUxId6hm8Meta } from "/app/pages/screens/hr-evaluation/evaluate/ability/comp/PrevEvalResult.vue?macro=true";
import { default as IdpModalu6bJNLHWFPeFcQGBphH06s2wj5ktaHjhJ55zvwRhNTgMeta } from "/app/pages/screens/hr-evaluation/evaluate/common/comp/modals/IdpModal.vue?macro=true";
import { default as KrModal_45B_R2Igs4XxErfibqaqylzojAa82uXKepljcbVNhOW4Meta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/KrModal.vue?macro=true";
import { default as PerformEvalTabvrzg5O_tqS_E6UBRbOS_45cytQfsLSoYOrkc9EYaYYJ4cMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvalTab.vue?macro=true";
import { default as PrevEvalResultl00viITF0OBmJo44Oxzos2z3KQ9rWvCI5ESzrnv3ZxMMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/PrevEvalResult.vue?macro=true";
import { default as ProcessEvalTabUyv87aaRWtNwedEFC8Sg3kUB_GcHQYkJjrpN52EGsrwMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/ProcessEvalTab.vue?macro=true";
import { default as widget01ZTRdytlaLhdQe1zJGSGW1Z0sKDdbpCea7fSKk6K7XrsMeta } from "/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget01.vue?macro=true";
import { default as widget02Hu77s55SwyTwMYRU4C2wIX9RdKmG3xy3QVKkYcB66vkMeta } from "/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget02.vue?macro=true";
import { default as widget03fxXSRE9gl_45vzgnq_9QqJuFgu9X9ReSylfSQdqpODIycMeta } from "/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget03.vue?macro=true";
import { default as widget04nPosr_45Kj1e9942qYTsPYaR3wtK3td2E3O9ejz3roi_YMeta } from "/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget04.vue?macro=true";
import { default as widget05t7AF0fa0ImtFJj2T4gY_CM3Jhd3k1l5iCjZmW0ek0PQMeta } from "/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget05.vue?macro=true";
import { default as widget06k6Kj5Ww9y0yUD18YpOhTFJdZBa6ES_dDkfFOgfhPT6sMeta } from "/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget06.vue?macro=true";
import { default as widget07PmXEqRNV5Zvqbpvt_45vKLpxk3Cg1CWn8BSsGRviFajbYMeta } from "/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget07.vue?macro=true";
import { default as widget08VTndbMw63oXRUrfTwnHEDS_451QynhwVKfObFP55XQtccMeta } from "/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget08.vue?macro=true";
import { default as PageHeaderSJ0ck0X7F_KSneco9H9keWPEscOxEFtmx0CWz6OyKroMeta } from "/app/pages/screens/hr-evaluation/results/results-view/comp/PageHeader.vue?macro=true";
import { default as indexv3VBZTXNt3bw9_45wg4s9_456pC9_45WQf0Eqg9a_45LMBYZUoQMeta } from "/app/pages/screens/onboarding/onboarding-config/feedback-result/index.vue?macro=true";
import { default as indexTJpfuO_45WDuMwcg72WzNdUDj8QktJHzszNBjoINDQX20Meta } from "/app/pages/screens/common/config/password-change/password-change/index.vue?macro=true";
import { default as ManagerEvalResultModalvVqTF8YkGe5d414ftpFNsS4gE6tl0g19zaVQ50jB8cUMeta } from "/app/pages/screens/dashboard/manager/components/ManagerEvalResultModal.vue?macro=true";
import { default as ManagerImportPlanModalq05GbwUzx3_tUKMlmIEXf5k_JY2a9tP7nDKeBYemOZAMeta } from "/app/pages/screens/dashboard/manager/components/ManagerImportPlanModal.vue?macro=true";
import { default as ManagerKrTimelineModaleeBXp2Gtl6L_lG42o9bgWdHdS_45xbrjyxa4k_0AGPwvgMeta } from "/app/pages/screens/dashboard/manager/components/ManagerKrTimelineModal.vue?macro=true";
import { default as ManagerPerformanceTabsg8dRNRluz_459C5huBFt5DTOwwgECbR1p6Cyv7vTz27VoMeta } from "/app/pages/screens/dashboard/manager/components/ManagerPerformanceTabs.vue?macro=true";
import { default as ManagerTaskDetailPanelOH0jkrqwBvIJtcENJMx9vKKpBNMPNHb8NyMTMAgBoFoMeta } from "/app/pages/screens/dashboard/manager/components/ManagerTaskDetailPanel.vue?macro=true";
import { default as PersonalCalendarPaneleadpNyF0yizGlo54CduXsnR1aj_45nSC9xY76oqugTWU0Meta } from "/app/pages/screens/dashboard/personal/components/PersonalCalendarPanel.vue?macro=true";
import { default as KrCardYKxwTcjHhpXaX_4536UBWBspAv3xlZwCCAipj6SVV8LBYMeta } from "/app/pages/screens/hr-evaluation/calculation/perform/comp/cards/KrCard.vue?macro=true";
import { default as indexTsWOPwD4_45NkIrs98qQYqIxgZscIokVmaw9nsf4EOOygMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-results/index.vue?macro=true";
import { default as CapaItemModalHTYsUKeLe3N4v9jLe20iPlMbpzl4uE0Dpiwq1zUryC8Meta } from "/app/pages/screens/hr-evaluation/conf/targets/comp/modal/CapaItemModal.vue?macro=true";
import { default as KpiModalZlAJS7IVySQiBMOtZ5y_1ob2DbItkrkneIXV9dhyeU8Meta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/KpiModal.vue?macro=true";
import { default as PreviewModal9v1NeheGFizzLYai9CV6LwY4voyytsj3qEzjmS3EMWoMeta } from "/app/pages/screens/hr-evaluation/progress/evaluators/comp/PreviewModal.vue?macro=true";
import { default as ResultTableAx5BD2y4M4aA_45uVcl4TfJKYvER6muoEpwfN4IwW58LAMeta } from "/app/pages/screens/hr-evaluation/results/results-view/comp/ResultTable.vue?macro=true";
import { default as index1OF7ghFutqFRkj_OpyzZItedmp7T1xhsBI4l_mrWzmEMeta } from "/app/pages/screens/onboarding/onboarding-config/onboardig-target/index.vue?macro=true";
import { default as ManagerActivityTimelineEgTl4zYgxkXkqj0ZPYfGnS_45nK9p9DkueMpWabKkMABIMeta } from "/app/pages/screens/dashboard/manager/components/ManagerActivityTimeline.vue?macro=true";
import { default as ManagerAvtPlanListModal0f_x0LeBWPCE98Y6d2piqL_45qGvKrhuKNgqqiWhRWwO4Meta } from "/app/pages/screens/dashboard/manager/components/ManagerAvtPlanListModal.vue?macro=true";
import { default as ManagerKrCascadingModal1M7hU3n6LnjlgcVNgFyLorRPNkLWeZh1_IjWq3aZMPUMeta } from "/app/pages/screens/dashboard/manager/components/ManagerKrCascadingModal.vue?macro=true";
import { default as KpiCard0az5BLYshfu4va2T_7Ww_45gwmjlpuy3D0gaLJM3Gyj_45AMeta } from "/app/pages/screens/hr-evaluation/calculation/perform/comp/cards/KpiCard.vue?macro=true";
import { default as index6g71UPiT4S32cOaVELjISeaT9yr58OQfhDu_45AkYbs6AMeta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-dictionary/index.vue?macro=true";
import { default as PageHeaderAN5cI_GBpts51aK8gs3i_45ILMKtFRgv4mSyuF2fJ5314Meta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-scale/comp/PageHeader.vue?macro=true";
import { default as SettingSummaryModalg_45kNVevDtvfStpL6sxIGMDPiBStNGcXGomqv75MQSBwMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/SettingSummaryModal.vue?macro=true";
import { default as indexHFTRhVuS9YIBFwy0NnoNUpgt57IajohjRCo57_RKgWYMeta } from "/app/pages/screens/hr-evaluation/description/performance-template/index.vue?macro=true";
import { default as EvaluationHeaderw30QrolkwFM4qTVCnLxr4D5KodPZOTKPutchNTRunUoMeta } from "/app/pages/screens/hr-evaluation/evaluate/ability/comp/EvaluationHeader.vue?macro=true";
import { default as GuideModalj93rbjhplVaHN__45UlrxBhIiNhsoCpLFIOQ3mdIUivTUMeta } from "/app/pages/screens/hr-evaluation/evaluate/common/comp/modals/GuideModal.vue?macro=true";
import { default as PlanModalOmPUDfhgqyJulDImDOgc2O_79lvcwR1KiaALwG0uE20Meta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/PlanModal.vue?macro=true";
import { default as FeedTabItemrtJkqbzyIhHiTP4sDfNZApg_bDrE7Ix3B58hWe4LIPcMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/tabs/FeedTabItem.vue?macro=true";
import { default as PlanTabItemciLj2Rqlwolr3QbBIUjKGH4KYCY8MvhJysvKQl6Mq9QMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/tabs/PlanTabItem.vue?macro=true";
import { default as SendMailModal_twNTOxcHgjXu6KxCHzuZR_tCoBnTcbGfqJHP99MeasMeta } from "/app/pages/screens/hr-evaluation/progress/evaluators/comp/SendMailModal.vue?macro=true";
import { default as UsageYearLineChartaEBa7TlYm6V1kZCTjDZhklM40dsl_bqMS0jsherBhh0Meta } from "/app/pages/screens/common/config/ai-token-config/comp/UsageYearLineChart.vue?macro=true";
import { default as ManagerActivityDateGroupB3PP0jkQSN7zcmHJOIHkMh2n7Si8ixoYH5HyVQ55OTMMeta } from "/app/pages/screens/dashboard/manager/components/ManagerActivityDateGroup.vue?macro=true";
import { default as ManagerActivityFilterBarZNXkk_45jYYFc4yO1ZyG_FchZ0lDx33qvJxdDn7mDYxu0Meta } from "/app/pages/screens/dashboard/manager/components/ManagerActivityFilterBar.vue?macro=true";
import { default as ManagerActivityPlanGroup8AHwcM3fETwkfqAuHeIJnceZAaVExfTKpqDwdqf3hwkMeta } from "/app/pages/screens/dashboard/manager/components/ManagerActivityPlanGroup.vue?macro=true";
import { default as ManagerTimelineFilterBarWuXhya2_45vINWZlktbtNSy2Z_45aeOpZt4RTL_Vj2lkJWMMeta } from "/app/pages/screens/dashboard/manager/components/ManagerTimelineFilterBar.vue?macro=true";
import { default as ManagerWeeklyReportPanelnoF9wQrtDkLhfJI0nojN088LNps1MpVUm65Y_456HUxQYMeta } from "/app/pages/screens/dashboard/manager/components/ManagerWeeklyReportPanel.vue?macro=true";
import { default as PersonalDashboardHeaderxeZi4NrXM95OThQ9DmjZMBwARmIMMnUXz56kznfhwLsMeta } from "/app/pages/screens/dashboard/personal/components/PersonalDashboardHeader.vue?macro=true";
import { default as PlanCardadfoWcxy4dglDOeMrciI3Jbm85QW4rHy_453MDpbrC_7IMeta } from "/app/pages/screens/hr-evaluation/calculation/perform/comp/cards/PlanCard.vue?macro=true";
import { default as leftqqLxfrihHY0LrexU_45u5oUJ1J9YBl9z7Ka_uzZaxem2cMeta } from "/app/pages/screens/hr-evaluation/calculation/total/other-items/comp/left.vue?macro=true";
import { default as RatingGroup2x_Jdm18sdiESK2azYhHWCWmnqaicd8zkVZvCLN73sEMeta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-scale/comp/RatingGroup.vue?macro=true";
import { default as RatingPanelNvZ5DLgZ24_45QXSFb_45E7n1HCXhfjGuPOHKyAUEsuze1oMeta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-scale/comp/RatingPanel.vue?macro=true";
import { default as EvalCycleManageModalkvSJA_cmJv53YG5jmy19ggNGLVkElFvgKrVrE3_45ruAwMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/EvalCycleManageModal.vue?macro=true";
import { default as Step07AddTargetModalLLvfG8XFf_VDee55rGQHe6I80TOZSky48LI280sH3g8Meta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/Step07AddTargetModal.vue?macro=true";
import { default as PerformEvalFeedbackIconSLoeLMZgCxl25wXTZCs1McM_45iN9lDtjE0an5jG6rJ6EMeta } from "/app/pages/screens/hr-evaluation/evaluate/common/PerformEvalFeedbackIcon.vue?macro=true";
import { default as ObjectionDetailModalrrRnvNvl9Q5f6SdR6GzYAekRXBIyfnUrMKaZnO1Tn1wMeta } from "/app/pages/mobile/eval/evaluation-results/objections/ObjectionDetailModal.vue?macro=true";
import { default as RightqLFs9LhmNtbXJSlhR03iFMdMRRzUrIaeqIF6qAZAvMwMeta } from "/app/pages/screens/hr-evaluation/calculation/total/other-items/comp/Right.vue?macro=true";
import { default as InsaWizardTypedBubbleM66KXdtUWRW9AcveTNvaTHXLhZlpjwbnzx5JFf0nvnQMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/InsaWizardTypedBubble.vue?macro=true";
import { default as KrFeedTabItemanztuGG_45kwY6btVyDvNtgcrIqlWjcnxuCjOPQHCOt_45sMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/tabs/KrFeedTabItem.vue?macro=true";
import { default as indexN9m7MZnirMe_45JNQTFbkZ0P_XWWPGnc54pNgFeDbS7VAMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/index.vue?macro=true";
import { default as LeftXCLLNfVevYhkgcCmIJ78bGDblSG9NrDmgCF7UNee8sgMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-results/comp/Left.vue?macro=true";
import { default as indexcVF8f1QY6R_45MsWAY4bdP1ZM_450ZNsgm_45eIh0aRa_45lNFoMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/index.vue?macro=true";
import { default as FeedbackIconcYzR_45zHKMw1zMOBmUu_45oiafpx0LsGs_45oh68bOwGfh6AMeta } from "/app/pages/screens/hr-evaluation/evaluate/ability/comp/modals/FeedbackIcon.vue?macro=true";
import { default as AiHelperModalV38Pa6CoEB8frBYbloIhE3hFK3J_453qOCFbTqghfHhKkMeta } from "/app/pages/screens/hr-evaluation/evaluate/common/comp/modals/AiHelperModal.vue?macro=true";
import { default as FeedbackModalPb46z06SE59vyDQgeq1gN4YubyjWOsSwCUe_45SLZrF30Meta } from "/app/pages/screens/hr-evaluation/evaluate/common/comp/modals/FeedbackModal.vue?macro=true";
import { default as EvalRelModalJhutKcstj31nYwVQR9R2hyX_3AJ4WtYLJ6hfjlsAsr4Meta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/EvalRelModal.vue?macro=true";
import { default as ObjectionListModalZfI11TzEr3uhpVi5cbekOMGL2Dakv7yIDVzzBuMGcNoMeta } from "/app/pages/screens/hr-evaluation/my-results/comp/modals/ObjectionListModal.vue?macro=true";
import { default as EvalListTemplatee0qtyHSD_45loMrAnqRkoaMyjPj0WvXwW0aTtYBhcjYWIMeta } from "/app/pages/screens/hr-evaluation/progress/evaluators/comp/EvalListTemplate.vue?macro=true";
import { default as PageHeader1BibTrQJOAiQDnf8Qf8tdPUA94w3qXg85bGBfOZRoAAMeta } from "/app/pages/screens/hr-evaluation/results/total-result-view/comp/PageHeader.vue?macro=true";
import { default as index3wl5cZhkfqjzUSviyNSnmqfxzW3Q9KPc4P_WxIfIgSYMeta } from "/app/pages/screens/onboarding/onboarding-config/onboardig-monitoring/index.vue?macro=true";
import { default as RightTmBhe5kUbjMlWhckIXo0c36_45H3uMZF3V1AW4Vc4UvzAMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-results/comp/Right.vue?macro=true";
import { default as EvalItemModaliPYNp5rvYL5Dr8Vl8ja2FzndcZIMYnxobyp6md6YpdEMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/EvalItemModal.vue?macro=true";
import { default as KpiActualListT6DjOxFKXXT_8TkpfLlq_45_45KQV1Y8JFwrsnHyxghgl3MMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/KpiActualList.vue?macro=true";
import { default as AbilityEvalBarChartO7sSH5wE_RFkNkIYoJ5aW6pVpltDbXl2tGEu_45Ia4wucMeta } from "/app/pages/screens/hr-evaluation/my-results/comp/modals/AbilityEvalBarChart.vue?macro=true";
import { default as EvalStatsTemplateCt_HV3vFTAZikFMKt1iRfvzEAitQGCUonzB9WShz_Z8Meta } from "/app/pages/screens/hr-evaluation/progress/evaluators/comp/EvalStatsTemplate.vue?macro=true";
import { default as PageHeaderwmFmW14_45hyB_45tiGN_45Yw7yECch_45HZFHfBd16A6ySz_45twMeta } from "/app/pages/screens/hr-evaluation/calculation/org-calculation/comp/PageHeader.vue?macro=true";
import { default as AdjustModalmIKGkm_45xODcaLb_45PXKKNVaqWjEGyaNj0OOprER4FkmcMeta } from "/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/AdjustModal.vue?macro=true";
import { default as PageHeaderfZ1N8gN7erwhr8EHXgodXeV35TNmpHZolSQtdJ7UQp0Meta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/PageHeader.vue?macro=true";
import { default as Step07EvalDistriMngModalkviml7Z_45NlFOLJtZLWgLDAVWFEh4BJuYRxsYUC1yxdgMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/Step07EvalDistriMngModal.vue?macro=true";
import { default as Step07GrpUserAssignModalp0u7XkIppMBEdYQTJutk5BFjQPCXus4V51_VIAyLyn4Meta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/Step07GrpUserAssignModal.vue?macro=true";
import { default as PageHeaderJlOGw6_45xrkupzeH8t1eT8myfYHByKLM7tPM_457rdR55YMeta } from "/app/pages/screens/hr-evaluation/description/job-description/comp/PageHeader.vue?macro=true";
import { default as AbilityEvaluationCelleW9Zufokv26oMelA9qHIaRjMR1t_451gRF8G32Lxpgd_4Meta } from "/app/pages/screens/hr-evaluation/evaluate/ability/comp/AbilityEvaluationCell.vue?macro=true";
import { default as KrFeedbackListPM3PxOwXBEtSS9PIeWgVV12J3BgsQ0Pdl3TA1QMbYQkMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/KrFeedbackList.vue?macro=true";
import { default as EvalOpinionViewModalbc9axn_45aqijhGZesAPTdov5dNHtfsxF_PKjkArLSBV4Meta } from "/app/pages/screens/hr-evaluation/my-results/comp/modals/EvalOpinionViewModal.vue?macro=true";
import { default as ObjectionDetailModalWzfsWfOPrcXT3oZMLCj_45FHZLAbYBU4Bf7jlKGCL67ogMeta } from "/app/pages/screens/hr-evaluation/my-results/comp/modals/ObjectionDetailModal.vue?macro=true";
import { default as ObjectionSubmitModal8JhjGS329hcxshJR80oYQJvPBYYuq449R7Bum_45WgIb4Meta } from "/app/pages/screens/hr-evaluation/my-results/comp/modals/ObjectionSubmitModal.vue?macro=true";
import { default as PageHeader4H2Tv4MImyzBBt_sHbwU04DmcjqjqqYCUok5uyuo2HkMeta } from "/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/PageHeader.vue?macro=true";
import { default as Step07CapaItemPickerModalKGIuS6i6p0r31_45dyOsWTbMFxl_45pwzQ2ATqeUEquSu1YMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/Step07CapaItemPickerModal.vue?macro=true";
import { default as AbilityEvaluationTableifuzOJ7HgCpHjbmF_45B2d7X7EOG5OpI9OIFsfvxe_45sXwMeta } from "/app/pages/screens/hr-evaluation/evaluate/ability/comp/AbilityEvaluationTable.vue?macro=true";
import { default as ProcessEvaluationTabletuGz4ju1aHGHqKyd6XIZXPaRemYdOSjqBxZ__45BQZFxIMeta } from "/app/pages/screens/hr-evaluation/evaluate/ability/comp/ProcessEvaluationTable.vue?macro=true";
import { default as AbilityEvalRadarChartdick_45Ea0Z0qosma0YOqEyk52zSQCT_45WbwEIDos7q5g0Meta } from "/app/pages/screens/hr-evaluation/my-results/comp/modals/AbilityEvalRadarChart.vue?macro=true";
import { default as EvalRateModal0G1dmXWYCuknNSIdk2dJ5Skb3iqztaFG4lSJd9YV4hUMeta } from "/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/EvalRateModal.vue?macro=true";
import { default as PageHeaderEOIgo2V_458ADXZNPWWtmJwuJoEuiMfHK5s7dtC6_456u_45AMeta } from "/app/pages/screens/hr-evaluation/calculation/total/other-items/comp/PageHeader.vue?macro=true";
import { default as LeftOZzWnStguFZYJoF53rWz_45Hqsxi51SZT8wSWqNPpxMJkMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/Left.vue?macro=true";
import { default as GradeAdminTN5_CqlfY7BBdL8NuCl3O672C55hnCZJMSjmdI8Z22QMeta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/GradeAdmin.vue?macro=true";
import { default as GradeGroupQNOJTPYmgdC3NRskd9eVNpWzP2XRm8B75DboIACwoWIMeta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/GradeGroup.vue?macro=true";
import { default as PageHeadergeAKPJnOL64w2xo6yHkJ1jvvRj_0IohsScLi8rmDIj8Meta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/PageHeader.vue?macro=true";
import { default as Step07EvaluatorConfigModalmG5ADWao_m8fx_4593LFV9V8Qlu2PTs26w1E0fwowmCaMMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/Step07EvaluatorConfigModal.vue?macro=true";
import { default as DeployEvalTargetModalgbNAe9EEwhHwLR_45MZOUALAVNQjGpeosOSK_45cEBLG3SIMeta } from "/app/pages/screens/hr-evaluation/conf/targets/comp/modal/DeployEvalTargetModal.vue?macro=true";
import { default as EvalOpinionModalCnIrbNInQapUq_45p_45VE7HmbJKnkVVEPy_95PHuX4r3JwMeta } from "/app/pages/screens/hr-evaluation/evaluate/ability/comp/modals/EvalOpinionModal.vue?macro=true";
import { default as EvalOpinionModalE_45VvFA2GUQy5pmr9k0ayFEWQITsFUMJ_JoiuvP4TEXcMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/EvalOpinionModal.vue?macro=true";
import { default as PlanActivityListP1K3sbBsoeZ4qTVgZ459gnN4KGdgcjThGgqoNrK3IzIMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/PlanActivityList.vue?macro=true";
import { default as PerformEvalModelSectioniou3VEGjMASOoOvzdRmFOdwHTGuENr3ZSmy7pGYIsdoMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvalModelSection.vue?macro=true";
import { default as PerformEvaluationHeaderKryT8maWfqEXK7r84nsUWkmM5BvvWeN_45Fe_45NNCfNr00Meta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvaluationHeader.vue?macro=true";
import { default as RightpWp_IFW2JAAnBYwfekth4J3eLu1bET4ACY2o0KU9Kl0Meta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/Right.vue?macro=true";
import { default as BulkEvalTargetSettingsModald3Qk13LiyUN1U72_45lttufYIEkuE8aFr2atpZZ_458lzaAMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/BulkEvalTargetSettingsModal.vue?macro=true";
import { default as Step07EvalTargetConfigModalGFLy7qQyg_leHrFpWkAAfkWDBdZhXi2p_u3YlfigJZQMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/Step07EvalTargetConfigModal.vue?macro=true";
import { default as PageHeader8gvEaBxg6A6lX7LpvrWmZ59idomKXDEiiaNY_45WYgtUsMeta } from "/app/pages/screens/hr-evaluation/description/description-status/comp/PageHeader.vue?macro=true";
import { default as PerformTmpltModal0YPZBUsWjAMr4U2u1pOtE6EpHLGgD54FZKCiXyn9TkcMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/PerformTmpltModal.vue?macro=true";
import { default as PerformEvalAiEvalPopoverBvyDCU8RUBXspZAmszC9k_456A545AAAAf8usGOnNnPlYMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvalAiEvalPopover.vue?macro=true";
import { default as NotEndEvalTargetModallUEkZjF_wWeEcPc8F3SUE8_7u1_ljMrtbB2y27R29REMeta } from "/app/pages/screens/hr-evaluation/progress/evaluators/comp/NotEndEvalTargetModal.vue?macro=true";
import { default as indexVVVKuShY8aWvg_P4wfKV5DeV_45Jfy8bpot0K_45a7vMIlsMeta } from "/app/pages/screens/org-performance/org-performance-monitoring/org-diagram/index.vue?macro=true";
import { default as PageHeader0g53KjNOCqitv37FkfLiZwLR1UUSKDPDvx7DtSAPs_EMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-results/comp/PageHeader.vue?macro=true";
import { default as HreTimeSeriesModalOudJO8o4pPWMKbIuWpwD9_45G5E99KAXmHOOyvLYIUytMMeta } from "/app/pages/screens/hr-evaluation/results/row-data/comp/modals/HreTimeSeriesModal.vue?macro=true";
import { default as PageHeadery3KznpGVT5OvaDB1S0NXS8RSxhHS8fGU9mmz2B27BSoMeta } from "/app/pages/screens/hr-evaluation/description/performance-template/comp/PageHeader.vue?macro=true";
import { default as EvalOpinionModalBaseqxY_45AMgqkM9DH_45eUJUIWz1VZwzQL_45Wti_0QseHwdsaAMeta } from "/app/pages/screens/hr-evaluation/evaluate/common/comp/modals/EvalOpinionModalBase.vue?macro=true";
import { default as JobDescriptionModal1wa2gOTw4cAmQCayAfzWlotRZ2Us8rF7YFBbpXu6FV8Meta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/JobDescriptionModal.vue?macro=true";
import { default as PerfStmtAllPdfModalVHirYOpkDkTm5ODzjl_45AgVsrUaxq73uVHbBVFL72PCsMeta } from "/app/pages/screens/hr-evaluation/results/row-data/comp/modals/PerfStmtAllPdfModal.vue?macro=true";
import { default as TaskDescAllPdfModalkLjc_45VOfeU9QdSHC9RdCoJ74FwqRtDNvkI5lnNljmfYMeta } from "/app/pages/screens/hr-evaluation/results/row-data/comp/modals/TaskDescAllPdfModal.vue?macro=true";
import { default as indexqevcBjYcA7Pw612NTiupulDv5d6hnCfjEliHH7hmW00Meta } from "/app/pages/screens/org-performance/org-performance-monitoring/kpi-cascading/index.vue?macro=true";
import { default as EvaluationGroupG23lDLb7s3Clh_UeeTnNAYiUHXY2zGYApMu_3_YdV24Meta } from "/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/EvaluationGroup.vue?macro=true";
import { default as AbilityEvalResultViewModaleCEZSnZ9dFJBeI_45lRVYgpSJ_45bU0dSylH9MhF6oeTG7wMeta } from "/app/pages/screens/hr-evaluation/my-results/comp/modals/AbilityEvalResultViewModal.vue?macro=true";
import { default as PerformEvalResultViewModalpGJn4EdYKbvj4sCQoKaQbjVAJo19Y6hRbc3hJcw7ES8Meta } from "/app/pages/screens/hr-evaluation/my-results/comp/modals/PerformEvalResultViewModal.vue?macro=true";
import { default as DownloadPreviewModalVTY_45Te1SndK6esRPYVqPtMiHtpg8_45iQFqGiYU6dzAr8Meta } from "/app/pages/screens/hr-evaluation/results/row-data/comp/modals/DownloadPreviewModal.vue?macro=true";
import { default as EvaluationDetail1Bpx_45WzBxJdfqaihtl4uYlzBuisuKyKev8W3ITWiJLcMeta } from "/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/EvaluationDetail.vue?macro=true";
import { default as PerformanceGroupFM16SVpdR1ySk1xnXLhuFCs8B4lbY44C9EhOLu7l4FAMeta } from "/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/PerformanceGroup.vue?macro=true";
import { default as PerformanceItems39RkD4pcOzmV_4qbjK2vghtmCGAtHD54Qmz_45twFwssQMeta } from "/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/PerformanceItems.vue?macro=true";
import { default as PerformancePanelpfOP_45ujMnf8hkA1rQ2qsfAZSJCLuy7LYajgpTRLH46sMeta } from "/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/PerformancePanel.vue?macro=true";
import { default as TemplateListf_45GGZmdN7w5_452E04JtIecRlAguSiNuLjHE2f9lfv_455IMeta } from "/app/pages/screens/hr-evaluation/description/performance-template/comp/TemplateList.vue?macro=true";
import { default as AdjustReasonModalJXYmMD9UHM3X2f3g_45k6WSJQ1Yj2FbYEo80eifm7p1I4Meta } from "/app/pages/screens/hr-evaluation/results/results-view/comp/modals/AdjustReasonModal.vue?macro=true";
import { default as indexr1V13HOpvHzbSePAql7G9F0RJUoAccSeyDFXH2Q5LtoMeta } from "/app/pages/screens/org-performance/org-performance-monitoring/org-grp-compare/index.vue?macro=true";
import { default as indexZCaryG2ibvKO6Ah423DuvcrVujt_W9Ia95x1KGiShTUMeta } from "/app/pages/screens/org-performance/org-performance-monitoring/org-kpi-compare/index.vue?macro=true";
import { default as HreExcelResultModal7W5OAFsc6Ym4bbqYVfvMRqT0M_45i_JNOdxPw5Bg7dArwMeta } from "/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/HreExcelResultModal.vue?macro=true";
import { default as PageHeaderykyqIey6cxTLP2NJ6_450D5BjMRDAEVfwtV1a9iIJb_i0Meta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/PageHeader.vue?macro=true";
import { default as EvalSettingsTemplatePreviewModalsmouuKTWQT6D_l5XF3FDZe1oRqG0DEnq0RazQBMtiC0Meta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/EvalSettingsTemplatePreviewModal.vue?macro=true";
import { default as SearchModallDRd11UDdsoYugcszudxjGiJOFJ3GvuLKZH95WC89YMMeta } from "/app/pages/screens/hr-evaluation/description/job-description/comp/modals/SearchModal.vue?macro=true";
import { default as PageHeaderQRhZFdOtaFx3w0ZOJhHSt__45a4TXWIa_5oX0cH1XRk_45wMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/PageHeader.vue?macro=true";
import { default as PerformEvalKpiKrReadonlyCards4ndybhrvPE_45tiJZkpyCKV5W_kdOK0MKIAyalhmWeKWEMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvalKpiKrReadonlyCards.vue?macro=true";
import { default as HreAllExcelResultModalss0fm0qZgCPlKqKQ_rzSmri5yr5dEPWUBKTeq2gIubcMeta } from "/app/pages/screens/hr-evaluation/results/row-data/comp/modals/HreAllExcelResultModal.vue?macro=true";
import { default as CompetencyInfoPanelW1CPB6Th_fWQvOa7PI5iVfNEACtGoIxP_45mlKfYqyrjYMeta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/CompetencyInfoPanel.vue?macro=true";
import { default as NcsDictModalh4x32puu_ZkF6yYQdHNY3B8jf9tPRsKsJgo92iqOpFUMeta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/NcsDictModal.vue?macro=true";
import { default as SettingModalSR3uZAN1lfBDK5S8xU6Piydc32W_45qhi3_W74JW75d1IMeta } from "/app/pages/screens/hr-evaluation/description/job-description/comp/modals/SettingModal.vue?macro=true";
import { default as PerformEvalKrFeedbackEvalBadge4mcP78V4snhCN8InGLjbZn6QNwQ2F6o8RSpr6cosmwcMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvalKrFeedbackEvalBadge.vue?macro=true";
import { default as ComponentHreAbilityResultModalVba5hA3z1juWQT_N4D_45ZrB4oPoapn5Z6lUTNjfk4jL4Meta } from "/app/pages/screens/hr-evaluation/adjustment/comp/modals/ComponentHreAbilityResultModal.vue?macro=true";
import { default as ComponentHrePerformResultModalOlz6mBuP8PnMWGmD_45yGV95UdJvcmeqo4NN8qxNlJloEMeta } from "/app/pages/screens/hr-evaluation/adjustment/comp/modals/ComponentHrePerformResultModal.vue?macro=true";
import { default as BulkFormSettingsModalyU_453tHQrnV8ELE3o2NYkvXph6Unm_45bx9N0z3LLFAZNUMeta } from "/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/BulkFormSettingsModal.vue?macro=true";
import { default as HreAbilityResultModalrHkfIqf44k7QHCSOVXXa7wN6lSe4dG17IzH9dosLkdIMeta } from "/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/HreAbilityResultModal.vue?macro=true";
import { default as HrePerformResultModaliS_IUBcsAMC0q69Zvyfzd9T6lCqG_Z3ndYrrwmLYIOoMeta } from "/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/HrePerformResultModal.vue?macro=true";
import { default as CellRendererohrqN9E4OUqq_dnzL3wwez2wrQVFBcECqaxNV4BSETEMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/CellRenderer.vue?macro=true";
import { default as CmptItemModalxNGQSCuGBeJgXTDKk4bv5vbaSsWcJrEq2cz8GlYjdgoMeta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CmptItemModal.vue?macro=true";
import { default as CategoryModallIdTB_4529ZOMjIvnsrbq9nKOmS4Lk3NrHoUwWJVnGoRkMeta } from "/app/pages/screens/hr-evaluation/description/job-description/comp/modals/CategoryModal.vue?macro=true";
import { default as SettingsPanelUALnxB6_45_dUGgpsqSyk_kRSTl25jZSohz89qQqq7UHEMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/SettingsPanel.vue?macro=true";
import { default as EvaluationGroupManagerrMaBTSTMJ6tLI4JtGDnEHs4Qn4Cc5_45UKJnaaxFzys8kMeta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/EvaluationGroupManager.vue?macro=true";
import { default as PreviewModal3zLx6K3pX_4516L4rlGXBht9PLedbME1M79Wc5E5LlZKwMeta } from "/app/pages/screens/hr-evaluation/description/description-status/comp/modals/PreviewModal.vue?macro=true";
import { default as AttachmentModalTLgKpIrHaTbx5_45HI5BHW8QevI_45_45LPbis7_0Z17v_45MdEMeta } from "/app/pages/screens/hr-evaluation/description/job-description/comp/modals/AttachmentModal.vue?macro=true";
import { default as CopyTemplateModal0GzoleEEycX_4578aBPmQSNjezWFD9t9zh43udm_455TahQMeta } from "/app/pages/screens/hr-evaluation/description/performance-template/comp/CopyTemplateModal.vue?macro=true";
import { default as PerformEvalEvidenceSummaryButtonsowFLAgSI8x1qDJBTRBCl5C9GesG3oGmLwJkiWvQ7OjUMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvalEvidenceSummaryButtons.vue?macro=true";
import { default as CalculationSettingsModalo6NyThmd8SCAXjp0MaaddcsdIli4U4Os_45hAdOVHBUvEMeta } from "/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/CalculationSettingsModal.vue?macro=true";
import { default as CopyCmptGrpModalb0L3Lo7O38Wr_45baCj2jObFDxxVciFBBHaV8z_45TOfAI8Meta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CopyCmptGrpModal.vue?macro=true";
import { default as InsaWizardPhaseGrp30F7aNTaYkZz2kHRUCnamEJ4b3qKpyjFICuSriHCEosMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseGrp.vue?macro=true";
import { default as SendMailModaleP7cR5YxFChWl30aMZLcenueS_zbvK8MTaAsneLFBl4Meta } from "/app/pages/screens/hr-evaluation/description/description-status/comp/modals/SendMailModal.vue?macro=true";
import { default as JobDescriptionTabstS4lE2KZAaaIChnbuOWKWbja1JpGvMl32bEnvctonUoMeta } from "/app/pages/screens/hr-evaluation/description/job-description/comp/tabs/JobDescriptionTabs.vue?macro=true";
import { default as TemplateFormEditortXfcwL63yHwvF3yTftzgg1gAibi5MkZQMx7G9sVyDmsMeta } from "/app/pages/screens/hr-evaluation/description/performance-template/comp/TemplateFormEditor.vue?macro=true";
import { default as CalculationPanelrlSHOIPK3MQLoWhmf4Ck_45Z6vSj27RqFCJPyHLYJB9wIMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/CalculationPanel.vue?macro=true";
import { default as CmptDictCopyModal1zoohZ2VT6GFUbzPm7MS9jzl2x09rs4Tr6jnCZZhKtkMeta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CmptDictCopyModal.vue?macro=true";
import { default as GradeDistributionPanelCWvkk0GfLoerUVgpDRjNkzIHArRUBbU7pFCJlTQqIm0Meta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/GradeDistributionPanel.vue?macro=true";
import { default as RatingGroupImportModalNRSZjx_so97XWAZJF4KOlDtA_45OxVx8p_L3C44QAb_6QMeta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-scale/comp/modals/RatingGroupImportModal.vue?macro=true";
import { default as InsaWizardPhaseCapa8AedjISRtJCz3uN2_45bNX56u_45Mi8_45gEfQJ01XJOgs5QIMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseCapa.vue?macro=true";
import { default as InsaWizardPhaseInsaT9q5jk0vYUkFexMuf5sHhsAydV_Vc4I_KkkCZiUPkrsMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseInsa.vue?macro=true";
import { default as InsaWizardPhaseMain9pjqr3YOosPjJu50kgthffU4xmES_45GPs0BaTdkY8X_45wMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseMain.vue?macro=true";
import { default as TemplateTableEditornSzygEQApS1xiZCrWnFGzNIpW__3BXMrJ7n5VQ7Xr44Meta } from "/app/pages/screens/hr-evaluation/description/performance-template/comp/TemplateTableEditor.vue?macro=true";
import { default as indexdUUWGz5WT4KT9mykby1YRBQeD2_uplegFInPNK7zHc4Meta } from "/app/pages/screens/org-performance/org-performance-monitoring/org-performance-detail/index.vue?macro=true";
import { default as InsaWizardPhaseCycleTWV2w43zeESWFoGDjeMJMOtSbcpFE4JpGGWcpOnXQVwMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseCycle.vue?macro=true";
import { default as InsaWizardPhaseLevelbkpRIvwlNFf8fXf2FdP7Fs0LC4mi8jbQbeu_YfEOGS0Meta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseLevel.vue?macro=true";
import { default as CommonTemplateEditorp5C0oldseugVqPKf46AscOX4fjTKkMPwRCsuwv3Dd0QMeta } from "/app/pages/screens/hr-evaluation/description/performance-template/comp/CommonTemplateEditor.vue?macro=true";
import { default as TemplatePreviewModalQnYwsM9F_zuCvAe1gZG3YNw6elFLMqAc3xNmMA55J7oMeta } from "/app/pages/screens/hr-evaluation/description/performance-template/comp/TemplatePreviewModal.vue?macro=true";
import { default as AiEvidenceSummaryButtonqZoYIGh449GDJ66V5uaS_dA_454onudHUwoi4LD7aFNhkMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/ai-perf-stmt/AiEvidenceSummaryButton.vue?macro=true";
import { default as indexfSAxUPfxfYsEIP1v_5SMaHn04JR2CEPQQbdPfLaaptQMeta } from "/app/pages/screens/org-performance/org-performance-monitoring/org-performance-summary/index.vue?macro=true";
import { default as GradeDistributionManagerCw2I9G2FJ0688c5IpSBg7rWRI01YvFSghIsJov0RDZ4Meta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/GradeDistributionManager.vue?macro=true";
import { default as InsaWizardPhasePeriodXq1BsYd36UE7ePSvAD77g3P3jkYbObPKXxCpyVD2Y5cMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhasePeriod.vue?macro=true";
import { default as InsaWizardPhaseResultKQTsJVfMvFAU0A0kBkmMt1NgO_5tVuKBFF1u_gdrJtYMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseResult.vue?macro=true";
import { default as OtherManagerInvolvedEvalTargetModaltSTOLMiekSk9edygSJHcnOUL1NZvu6dJZXBqnOAJOR8Meta } from "/app/pages/screens/hr-evaluation/conf/targets/comp/modal/OtherManagerInvolvedEvalTargetModal.vue?macro=true";
import { default as SearchModal7gbuxScXZJ7WJ2MqFEBltWUE67uOPTK5W8l6TMcCMM4Meta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/SearchModal.vue?macro=true";
import { default as CompetencyGroupSidebarGPwThqNaaWlUR0G7W8iKie57L_45pEVzekchMQJRc19jwMeta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-dictionary/comp/CompetencyGroupSidebar.vue?macro=true";
import { default as CmptDictModDataModalaf61Z7y2GhohAxwKoWy7foNeBuklPMVLKdcR0RdT3oEMeta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CmptDictModDataModal.vue?macro=true";
import { default as CommLdrCmptDictModalmrOIBzfVlInxfdZA_XYq8inuEGoYmvB5FJo0mNqhaFIMeta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CommLdrCmptDictModal.vue?macro=true";
import { default as InsaWizardPhaseAbilitytwrILlxDoa_NAp5kc3wrBlI_yGyAxwct7L2ysycMpzsMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseAbility.vue?macro=true";
import { default as InsaWizardPhasePerfmdl_Aqf2qn8YjJBOvRjq1XkON9EqWHjC5ExSGn3lqxlcUcMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhasePerfmdl.vue?macro=true";
import { default as InsaWizardPhasePerformt_45CATR3_63uvOfjFS7EXgvYNuroI4PuK7JAtxt5joy8Meta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhasePerform.vue?macro=true";
import { default as SettingModalG_45Ke94mx7GCeAWv4zpcRwdH_45q0ox4ttYB6h1joIFkeIMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/SettingModal.vue?macro=true";
import { default as PerformEvalEvidenceSummaryModalz0lR5cbpReaUM9bclOo_EYDCGWxKOGS1oyu7rQvBIIoMeta } from "/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/PerformEvalEvidenceSummaryModal.vue?macro=true";
import { default as CompetencyDetailManageruIUjIAulCDqLw8QnANzCdVk7cNqfw7wqVyaIPF3e4QMMeta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-dictionary/comp/CompetencyDetailManager.vue?macro=true";
import { default as CategoryModall5m9TNfzG1eGPu9dEN9rDtYCWIcrXebaiOONIPtyfFwMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/CategoryModal.vue?macro=true";
import { default as TargetAddModalqVHMJ9OflEwl8Q7Frf5jf_45n45UjVDcM3SwXALPVyCTMMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/TargetAddModal.vue?macro=true";
import { default as FormTypeTemplate0qWCzlZOZKAcsTrTiY1tFNsmAciz4Mka489zU0eftVgMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/tabs/FormTypeTemplate.vue?macro=true";
import { default as ItemTypeTemplate2_Wck69lhMu1LSHvbE14O9KPZrPyTwFX_nc37kx_2rQMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/tabs/ItemTypeTemplate.vue?macro=true";
import { default as index2CDRTnfYtC__45VkyjCnYwDpaSA4s_SQLthHaaT_45JlOH8Meta } from "/app/pages/screens/org-performance/org-performance-monitoring/org-performance-action-plan/index.vue?macro=true";
import { default as GradeGroupImportModalaVd1mA0ZGoxNal56ub_aSKBvbcfK6RrFHyiDTQrCpuMMeta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/modals/GradeGroupImportModal.vue?macro=true";
import { default as InsaWizardPhaseMultiphase5_9STzlzrQy8EsJ9sX4CYFLtyKjyUHvy2gQi2rZbNXcMeta } from "/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseMultiphase.vue?macro=true";
import { default as AttachmentModalhMhx9SriVDunWnZmkFJ5RwXGg6_45qxqBzahS47uNL2H8Meta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/AttachmentModal.vue?macro=true";
import { default as TargetRatioModalp5hLzItL3FIqzWTrHCz2WJCA1UQeX9rlV_45Mra4ctKfIMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/TargetRatioModal.vue?macro=true";
import { default as EvalGrpImportModalp1wIzAm0AYTwDrXiMoolCl0ui1PTHYLuqKCgwHU_JxEMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/EvalGrpImportModal.vue?macro=true";
import { default as CompetencyGroupImportModalcdJA5HzWgIuqfdKeqDyKIDTRbDpZ4OfheAZk_45_MogpAMeta } from "/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CompetencyGroupImportModal.vue?macro=true";
import { default as FeedbackAsidePanelUXFyPhURjhMX3pamjjGV9xiu4pRb9lcx4NpPxMDl07cMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/panels/FeedbackAsidePanel.vue?macro=true";
import { default as EvaluationGroupImportModal1k1SGUwGD9xpp_45eUkso7OMamZi55McczmnV_45OFTNMCoMeta } from "/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/modals/EvaluationGroupImportModal.vue?macro=true";
import { default as GradeManagementModalkSI5ycT9z4FFPBZA4KEhXmWSWmQf6OabFLz06fZfr_cMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/GradeManagementModal.vue?macro=true";
import { default as PerformanceGroupImportModal7aSRbhDdWKu8xQjvnji9TK8ZK7WlW_45BnFgGiQFMRJaYMeta } from "/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/modals/PerformanceGroupImportModal.vue?macro=true";
import { default as TotTargetRatioSectionH0rAsNlfoLWOxxI43qzA691Ez6W_5ZHFFjrPvNmDfMgMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/TotTargetRatioSection.vue?macro=true";
import { default as GradeDistributionImportModalLrB833PsTApUrf3bBo1oAoJqxd8seqYofKt4tlOJY70Meta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/modals/GradeDistributionImportModal.vue?macro=true";
import { default as BulkAdjustSettingsModal62RHIvNsr_4eVxvYgPuIiFex8NJOJOfmsHZPVFAqjusMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/BulkAdjustSettingsModal.vue?macro=true";
import { default as GradeDistributionDownloadModalqt4dwXbNBOG4vi3Glx8cgGJ2zvHBm4CqnutVUzgifPgMeta } from "/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/modals/GradeDistributionDownloadModal.vue?macro=true";
import { default as BulkCoordUserSettingsModaleEZ_45RZkbzY6C_45B6PryY_Cdbd6NFJOxBKECbgSHg0aKwMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/BulkCoordUserSettingsModal.vue?macro=true";
import { default as TotCalculationSettingsModalCWRvzjXZ8OtmrlSonPycU93u_457PEUCN4iCpF5RDhCm0Meta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/TotCalculationSettingsModal.vue?macro=true";
import { default as Step3GeneratingZ7UraaBfs3YtxVhq7V7u1nmutCiKo0HBe8FNjzJKF9sMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/Step3Generating.vue?macro=true";
import { default as Step4ReviewApplyAeg3WBD7b6EfaFZ85TAEOW8W1dStv_45I1JaJSttS9nAcMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/Step4ReviewApply.vue?macro=true";
import { default as PerformStatementContentModalYKHa4AR3cy2xMgkFDDZQbprYGrHsQsm178XlUpoVj3wMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/PerformStatementContentModal.vue?macro=true";
import { default as ComponentHreAbilityResultModal2oo2W6qVdFPBTr9h8sR7NZ7MA4AQkuDynMVbRYRb2RAMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/ComponentHreAbilityResultModal.vue?macro=true";
import { default as ComponentHrePerformResultModaluQCJp2gWTEGMqn3S7vxBzEmptsaCHPADK8oNXrZ6mYkMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/ComponentHrePerformResultModal.vue?macro=true";
import { default as Step1WriteMode_5gkI2c2_PvXWBOw7ljHerM_Imjro_6bsM_frdGssboMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/Step1WriteMode.vue?macro=true";
import { default as Step1TemplateSelectZ5QJnGlm_Mst2dX2bQ912tljyXtua4oapf7paJwbmg8Meta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/Step1TemplateSelect.vue?macro=true";
import { default as Step2EvidenceSelectnCNXgDAG6KqgXRuBGE5IuzLB0xEpS9_45xkEGoE4MYf58Meta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/Step2EvidenceSelect.vue?macro=true";
import { default as Step3GeneratingfODCcZl51aF_45w1zMv_45ojcydpCDuOsAaScnHVk03sy_45EMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/Step3Generating.vue?macro=true";
import { default as ComponentHreAbilityTotResultModalhQj2AR2E7qa5yOIBQ5ta96JUyrIFYXEPLUiiyBLZhDkMeta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/ComponentHreAbilityTotResultModal.vue?macro=true";
import { default as ComponentHrePerformTotResultModalj0XmJjAAsP41AIMIyHa2LqTrg75QvLle0nlOh5lL8A8Meta } from "/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/ComponentHrePerformTotResultModal.vue?macro=true";
import { default as Step4ReviewApplykKvEGOEVRKThSAY9eBji0FZsMvuQQhdd3iM7lg0Mi9wMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/Step4ReviewApply.vue?macro=true";
import { default as AiPerfItemHelpTipE4bTo9yPVy2NADcbIuLxFjwZKnAUgaSRFo67qdiwx_sMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/AiPerfItemHelpTip.vue?macro=true";
import { default as AiPerfStmtGenerateModal_abYi5nuqi54wgRVCq1Z4AfLcLX9H16ZK97ETw8YEw4Meta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/AiPerfStmtGenerateModal.vue?macro=true";
import { default as Step2EvidenceSelectB3EPGavttc67D8PeI09pPS1zsjrXw4yFX2xmjvlwEhIMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/Step2EvidenceSelect.vue?macro=true";
import { default as AiPerfItemGenerateModalsMZZMMHGxttgrsgBxRVIFkldYDbqS0GZ9Z_JVMhv2kAMeta } from "/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/AiPerfItemGenerateModal.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login.do",
    path: "/login.do",
    meta: {"middleware":"auth-check"},
    component: () => import("/app/pages/login.do.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/app/pages/dashboard.vue")
  },
  {
    name: "guide",
    path: "/guide",
    component: () => import("/app/pages/guide/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: index06RuUPKkpIkYJ1u5ZQ6kHhkE76Z6rwcTsSwg0fLJR9IMeta || {},
    component: () => import("/app/pages/login/index.vue")
  },
  {
    name: "components-Tag",
    path: "/components/Tag",
    component: () => import("/app/pages/components/Tag.vue")
  },
  {
    name: "components-Test",
    path: "/components/Test",
    component: () => import("/app/pages/components/Test.vue")
  },
  {
    name: "components-Alert",
    path: "/components/Alert",
    component: () => import("/app/pages/components/Alert.vue")
  },
  {
    name: "components",
    path: "/components",
    component: () => import("/app/pages/components/index.vue")
  },
  {
    name: "components-Input",
    path: "/components/Input",
    component: () => import("/app/pages/components/Input.vue")
  },
  {
    name: "components-Popup",
    path: "/components/Popup",
    component: () => import("/app/pages/components/Popup.vue")
  },
  {
    name: "components-Radio",
    path: "/components/Radio",
    component: () => import("/app/pages/components/Radio.vue")
  },
  {
    name: "components-Button",
    path: "/components/Button",
    component: () => import("/app/pages/components/Button.vue")
  },
  {
    name: "components-Layout",
    path: "/components/Layout",
    component: () => import("/app/pages/components/Layout.vue")
  },
  {
    name: "components-Select",
    path: "/components/Select",
    component: () => import("/app/pages/components/Select.vue")
  },
  {
    name: "components-Switch",
    path: "/components/Switch",
    component: () => import("/app/pages/components/Switch.vue")
  },
  {
    name: "mobile-home",
    path: "/mobile/home",
    meta: indexMW5kF9ynHm2eZ01T3ohkh9XOYOHTbuzTilXnJmP9tKUMeta || {},
    component: () => import("/app/pages/mobile/home/index.vue")
  },
  {
    name: "components-Confirm",
    path: "/components/Confirm",
    component: () => import("/app/pages/components/Confirm.vue")
  },
  {
    name: "components-Tooltip",
    path: "/components/Tooltip",
    component: () => import("/app/pages/components/Tooltip.vue")
  },
  {
    name: "components-Checkbox",
    path: "/components/Checkbox",
    component: () => import("/app/pages/components/Checkbox.vue")
  },
  {
    name: "components-Textarea",
    path: "/components/Textarea",
    component: () => import("/app/pages/components/Textarea.vue")
  },
  {
    name: "components-Accordion",
    path: "/components/Accordion",
    component: () => import("/app/pages/components/Accordion.vue")
  },
  {
    name: "components-UiSpinner",
    path: "/components/UiSpinner",
    component: () => import("/app/pages/components/UiSpinner.vue")
  },
  {
    name: "screens-logout",
    path: "/screens/logout",
    meta: indexlGlsh3TOD1thY_4cG0xBakv5AAN8oNSDW6u5362V2fQMeta || {},
    component: () => import("/app/pages/screens/logout/index.vue")
  },
  {
    name: "components-DatePicker",
    path: "/components/DatePicker",
    component: () => import("/app/pages/components/DatePicker.vue")
  },
  {
    name: "components-EditUiTable",
    path: "/components/EditUiTable",
    component: () => import("/app/pages/components/EditUiTable.vue")
  },
  {
    name: "components-TableDefault",
    path: "/components/TableDefault",
    component: () => import("/app/pages/components/TableDefault.vue")
  },
  {
    name: "screens-dashboard",
    path: "/screens/dashboard",
    meta: indexmDx2cS6VDDzuwjx60iPhIQ5SVzueWMdMM3dIwZEHWGsMeta || {},
    component: () => import("/app/pages/screens/dashboard/index.vue")
  },
  {
    name: "screens-pa-member",
    path: "/screens/pa/member",
    meta: indexgPd6dIjrhsIkBgtSR284Q422qzIxOhoyAIsg6APERCwMeta || {},
    component: () => import("/app/pages/screens/pa/member/index.vue")
  },
  {
    name: "screens-pa-report",
    path: "/screens/pa/report",
    meta: index_4591n0s9Apu4HB_45M1QTsx_45aaiFnpmdhRu1LVL9MQ_MoIMeta || {},
    component: () => import("/app/pages/screens/pa/report/index.vue")
  },
  {
    name: "screens-task-home",
    path: "/screens/task/home",
    meta: index4ZGHnC2BQY06L6MVW4sSgEaBky7b3ch7eCkgrhVmxhEMeta || {},
    component: () => import("/app/pages/screens/task/home/index.vue")
  },
  {
    name: "components-MultiSelector",
    path: "/components/MultiSelector",
    component: () => import("/app/pages/components/MultiSelector.vue")
  },
  {
    name: "screens-pa-dataset",
    path: "/screens/pa/dataset",
    meta: indexkVfNoa6lTWpO3W6ph063BZQaGncMMpZ7Bi_fxmR6kWsMeta || {},
    component: () => import("/app/pages/screens/pa/dataset/index.vue")
  },
  {
    name: "screens-common-test",
    path: "/screens/common/test",
    component: () => import("/app/pages/screens/common/test/index.vue")
  },
  {
    name: "screens-common-modal-modal",
    path: "/screens/common/modal/modal",
    component: () => import("/app/pages/screens/common/modal/modal.vue")
  },
  {
    name: "screens-pa-dashboard",
    path: "/screens/pa/dashboard",
    meta: index4uiGEgaNvJe0sGEHyWCLKQV6au5X7wwu3c4v1QsbgNUMeta || {},
    component: () => import("/app/pages/screens/pa/dashboard/index.vue")
  },
  {
    name: "mobile-common-auth-required",
    path: "/mobile/common/auth-required",
    meta: auth_45required8jX05MXNaRI380HSmCJNdjeQ_2WN_4kjhvAExpQU4xEMeta || {},
    component: () => import("/app/pages/mobile/common/auth-required.vue")
  },
  {
    name: "screens-hr-mgt-carrer",
    path: "/screens/hr-mgt/carrer",
    meta: indexOVDSMgpUYBfUw_BM5Y5ISGuKKYdD27VRfU_458IV048W4Meta || {},
    component: () => import("/app/pages/screens/hr-mgt/carrer/index.vue")
  },
  {
    name: "screens-task-handover",
    path: "/screens/task/handover",
    component: () => import("/app/pages/screens/task/handover/index.vue")
  },
  {
    name: "mobile-eval-evaluation",
    path: "/mobile/eval/evaluation",
    meta: index2EfKQ03yU3t26zsPRouVPESi2X3zmDDYk2uZiB4fftYMeta || {},
    component: () => import("/app/pages/mobile/eval/evaluation/index.vue")
  },
  {
    name: "mobile-password-change",
    path: "/mobile/password-change",
    meta: indexYqG3iRXjM8vIOcNNKFscFcHSr_JuIOK_Q9NDKVmv_o8Meta || {},
    component: () => import("/app/pages/mobile/password-change/index.vue")
  },
  {
    name: "screens-performance-idp",
    path: "/screens/performance/idp",
    meta: indexo_yr3Nkt4it8v8talPgakzPdQpbwkDMcYrJMjySzdMcMeta || {},
    component: () => import("/app/pages/screens/performance/idp/index.vue")
  },
  {
    name: "screens-performance-kpi",
    path: "/screens/performance/kpi",
    component: () => import("/app/pages/screens/performance/kpi/index.vue")
  },
  {
    name: "screens-performance-okr",
    path: "/screens/performance/okr",
    meta: index7s_UD5o60O9mU3jivGiv8He_3qakeuGZTX2eR1Pcm3oMeta || {},
    component: () => import("/app/pages/screens/performance/okr/index.vue")
  },
  {
    name: "screens-dashboard-usage-module",
    path: "/screens/dashboard/usage/module",
    meta: moduletu6JoMSAC410ZJuzjKFaZC69gQTgtAP3GsVla4Hun3AMeta || {},
    component: () => import("/app/pages/screens/dashboard/usage/module.vue")
  },
  {
    name: "screens-dashboard-manager",
    path: "/screens/dashboard/manager",
    component: () => import("/app/pages/screens/dashboard/manager/index.vue")
  },
  {
    name: "screens-dashboard-usage-general",
    path: "/screens/dashboard/usage/general",
    component: () => import("/app/pages/screens/dashboard/usage/general.vue")
  },
  {
    name: "screens-hr-mgt-salary-mgt",
    path: "/screens/hr-mgt/salary-mgt",
    meta: index2oMRV68TmyYOiBCkf9jGhT5DQvfB8Neqq7P4CDHV_45_45QMeta || {},
    component: () => import("/app/pages/screens/hr-mgt/salary-mgt/index.vue")
  },
  {
    name: "screens-task-reports-view",
    path: "/screens/task/reports/view",
    component: () => import("/app/pages/screens/task/reports/view/index.vue")
  },
  {
    name: "screens-dashboard-personal",
    path: "/screens/dashboard/personal",
    component: () => import("/app/pages/screens/dashboard/personal/index.vue")
  },
  {
    name: "screens-dashboard-timeline",
    path: "/screens/dashboard/timeline",
    component: () => import("/app/pages/screens/dashboard/timeline/index.vue")
  },
  {
    name: "screens-performance-status",
    path: "/screens/performance/status",
    meta: indexX7tXCz7HDmv2N8tZGLatdyvX_45eZJSGf6KU3X_vBSa3sMeta || {},
    component: () => import("/app/pages/screens/performance/status/index.vue")
  },
  {
    name: "screens-project-my-project",
    path: "/screens/project/my-project",
    meta: index8C4l11VXM4V5ijW1SYJb91vp6LXWllk7IpZxH8WysqwMeta || {},
    component: () => import("/app/pages/screens/project/my-project/index.vue")
  },
  {
    name: "screens-task-collaboration",
    path: "/screens/task/collaboration",
    component: () => import("/app/pages/screens/task/collaboration/index.vue")
  },
  {
    name: "screens-pa-member-comp-PageHeader",
    path: "/screens/pa/member/comp/PageHeader",
    component: () => import("/app/pages/screens/pa/member/comp/PageHeader.vue")
  },
  {
    name: "screens-pa-report-comp-PageHeader",
    path: "/screens/pa/report/comp/PageHeader",
    component: () => import("/app/pages/screens/pa/report/comp/PageHeader.vue")
  },
  {
    name: "screens-task-reports-create",
    path: "/screens/task/reports/create",
    component: () => import("/app/pages/screens/task/reports/create/index.vue")
  },
  {
    name: "screens-dashboard-performance",
    path: "/screens/dashboard/performance",
    meta: index0Z1atb1Uuw8nwZLa2kes5D86YtB0bDuOyOoor74acgoMeta || {},
    component: () => import("/app/pages/screens/dashboard/performance/index.vue")
  },
  {
    name: "screens-dashboard-total-align",
    path: "/screens/dashboard/total-align",
    meta: indexf69ONnxgTjlTncEPB875WkvlwHsnWQ5NGHjjXy60gLoMeta || {},
    component: () => import("/app/pages/screens/dashboard/total-align/index.vue")
  },
  {
    name: "mobile-eval-evaluation-results",
    path: "/mobile/eval/evaluation-results",
    meta: indexxWWa_OljV2zfxgWX0LIFxZblXKq0FarPppsE9MATk1UMeta || {},
    component: () => import("/app/pages/mobile/eval/evaluation-results/index.vue")
  },
  {
    name: "screens-pa-dashboard-comp-PageHeader",
    path: "/screens/pa/dashboard/comp/PageHeader",
    component: () => import("/app/pages/screens/pa/dashboard/comp/PageHeader.vue")
  },
  {
    name: "screens-project-project-config",
    path: "/screens/project/project-config",
    meta: indexppJRcMQ2uVjFMx2V6R29h3cj_f9Q7PFNPijGJoQg9TUMeta || {},
    component: () => import("/app/pages/screens/project/project-config/index.vue")
  },
  {
    name: "screens-task-reports-comp-KPISection",
    path: "/screens/task/reports/comp/KPISection",
    component: () => import("/app/pages/screens/task/reports/comp/KPISection.vue")
  },
  {
    name: "screens-task-reports-comp-OKRSection",
    path: "/screens/task/reports/comp/OKRSection",
    component: () => import("/app/pages/screens/task/reports/comp/OKRSection.vue")
  },
  {
    name: "screens-dashboard-hr-evaluation",
    path: "/screens/dashboard/hr-evaluation",
    component: () => import("/app/pages/screens/dashboard/hr-evaluation/index.vue")
  },
  {
    name: "screens-hr-evaluation-diagnosis",
    path: "/screens/hr-evaluation/diagnosis",
    component: () => import("/app/pages/screens/hr-evaluation/diagnosis/index.vue")
  },
  {
    name: "screens-org-evaluation-org-eval",
    path: "/screens/org-evaluation/org-eval",
    meta: indexpHXFQiOV3XILmutx7cjrdDK2wi2wGxCPHu8dJ0kvUrYMeta || {},
    component: () => import("/app/pages/screens/org-evaluation/org-eval/index.vue")
  },
  {
    name: "screens-org-performance-org-kpi",
    path: "/screens/org-performance/org-kpi",
    meta: indexYzPb9hdBNv2luKCMImIIb8tzJ86_d3OFW_4561lraguVQMeta || {},
    component: () => import("/app/pages/screens/org-performance/org-kpi/index.vue")
  },
  {
    name: "screens-pa-report-comp-DonutChartCard",
    path: "/screens/pa/report/comp/DonutChartCard",
    component: () => import("/app/pages/screens/pa/report/comp/DonutChartCard.vue")
  },
  {
    name: "screens-pa-report-comp-PredictionCard",
    path: "/screens/pa/report/comp/PredictionCard",
    component: () => import("/app/pages/screens/pa/report/comp/PredictionCard.vue")
  },
  {
    name: "screens-task-comp-ReadStatusIndicator",
    path: "/screens/task/comp/ReadStatusIndicator",
    component: () => import("/app/pages/screens/task/comp/ReadStatusIndicator.vue")
  },
  {
    name: "screens-task-reports-comp-ReportsList",
    path: "/screens/task/reports/comp/ReportsList",
    component: () => import("/app/pages/screens/task/reports/comp/ReportsList.vue")
  },
  {
    name: "screens-common-help-desk-support",
    path: "/screens/common/help-desk/support",
    meta: index08zsnWyFUo_pM5IhykSqqk96_0JmJfn1Qqi6yZsWpqkMeta || {},
    component: () => import("/app/pages/screens/common/help-desk/support/index.vue")
  },
  {
    name: "screens-hr-evaluation-adjustment",
    path: "/screens/hr-evaluation/adjustment",
    component: () => import("/app/pages/screens/hr-evaluation/adjustment/index.vue")
  },
  {
    name: "screens-hr-evaluation-my-results",
    path: "/screens/hr-evaluation/my-results",
    meta: indexGBUw7FXkgSMe11Hi858O2XhGJzZ5ksnapJUxwv45qi8Meta || {},
    component: () => import("/app/pages/screens/hr-evaluation/my-results/index.vue")
  },
  {
    name: "screens-hr-mgt-base-info-my-info",
    path: "/screens/hr-mgt/base-info/my-info",
    meta: indexd_45ItR6MLffGk_45vI9e4niM8up__45IjDSPgAB8sh6beEWMMeta || {},
    component: () => import("/app/pages/screens/hr-mgt/base-info/my-info/index.vue")
  },
  {
    name: "screens-hr-mgt-base-info-org-mgt",
    path: "/screens/hr-mgt/base-info/org-mgt",
    meta: indexT44tUn3PeqDUr7m35ST0r_BFZxvMYSE0opziiB4la0AMeta || {},
    component: () => import("/app/pages/screens/hr-mgt/base-info/org-mgt/index.vue")
  },
  {
    name: "screens-onboarding-support-board",
    path: "/screens/onboarding/support-board",
    meta: indexV5akRhQgXm2_45qDnpT7Ej_fFD_rce1XI2Zv1uDeDAVJ8Meta || {},
    component: () => import("/app/pages/screens/onboarding/support-board/index.vue")
  },
  {
    name: "screens-common-config-code-config",
    path: "/screens/common/config/code-config",
    meta: indexwiTxSUHk168qfmMQqDdwE5CH43RVDXc9A3DS8MHx_45iMMeta || {},
    component: () => import("/app/pages/screens/common/config/code-config/index.vue")
  },
  {
    name: "screens-common-config-task-config",
    path: "/screens/common/config/task-config",
    meta: indexCQkdtbkrUQ_45pK_45jW3AG_I1q8NNciQju6w2W100ytvMEMeta || {},
    component: () => import("/app/pages/screens/common/config/task-config/index.vue")
  },
  {
    name: "screens-hr-mgt-base-info-user-mgt",
    path: "/screens/hr-mgt/base-info/user-mgt",
    meta: index8WNBp8MUA4iIPGzMxTjRovxC4qPdKWuXwQwbsvxLhnAMeta || {},
    component: () => import("/app/pages/screens/hr-mgt/base-info/user-mgt/index.vue")
  },
  {
    name: "screens-onboarding-welcomb-aboard",
    path: "/screens/onboarding/welcomb-aboard",
    meta: index6k1tSBsqPjSs4JgFkVK_45RXCNMCDAiOEhvzOWn2hhawUMeta || {},
    component: () => import("/app/pages/screens/onboarding/welcomb-aboard/index.vue")
  },
  {
    name: "screens-pa-report-comp-ChartDetailModal",
    path: "/screens/pa/report/comp/ChartDetailModal",
    component: () => import("/app/pages/screens/pa/report/comp/ChartDetailModal.vue")
  },
  {
    name: "screens-performance-kpi-comp-DonutChart",
    path: "/screens/performance/kpi/comp/DonutChart",
    component: () => import("/app/pages/screens/performance/kpi/comp/DonutChart.vue")
  },
  {
    name: "screens-performance-kpi-comp-PageHeader",
    path: "/screens/performance/kpi/comp/PageHeader",
    component: () => import("/app/pages/screens/performance/kpi/comp/PageHeader.vue")
  },
  {
    name: "screens-project-standard-template",
    path: "/screens/project/standard-template",
    meta: indexY3I7U8zXzi9xoB5N_45D4tA8tEF9gY2jyuKHABLranfJkMeta || {},
    component: () => import("/app/pages/screens/project/standard-template/index.vue")
  },
  {
    name: "screens-task-reports-comp-ReportsDetail",
    path: "/screens/task/reports/comp/ReportsDetail",
    component: () => import("/app/pages/screens/task/reports/comp/ReportsDetail.vue")
  },
  {
    name: "screens-task-reports-comp-ReportsHeader",
    path: "/screens/task/reports/comp/ReportsHeader",
    component: () => import("/app/pages/screens/task/reports/comp/ReportsHeader.vue")
  },
  {
    name: "screens-hr-evaluation-conf-targets",
    path: "/screens/hr-evaluation/conf/targets",
    component: () => import("/app/pages/screens/hr-evaluation/conf/targets/index.vue")
  },
  {
    name: "screens-pa-report-comp-MonthlyTrendChart",
    path: "/screens/pa/report/comp/MonthlyTrendChart",
    component: () => import("/app/pages/screens/pa/report/comp/MonthlyTrendChart.vue")
  },
  {
    name: "screens-performance-kpi-comp-DetailPanel",
    path: "/screens/performance/kpi/comp/DetailPanel",
    component: () => import("/app/pages/screens/performance/kpi/comp/DetailPanel.vue")
  },
  {
    name: "screens-performance-kpi-comp-MemberPanel",
    path: "/screens/performance/kpi/comp/MemberPanel",
    component: () => import("/app/pages/screens/performance/kpi/comp/MemberPanel.vue")
  },
  {
    name: "screens-task-home-comp-CollaborationChat",
    path: "/screens/task/home/comp/CollaborationChat",
    component: () => import("/app/pages/screens/task/home/comp/CollaborationChat.vue")
  },
  {
    name: "screens-task-home-comp-CollaborationFeed",
    path: "/screens/task/home/comp/CollaborationFeed",
    component: () => import("/app/pages/screens/task/home/comp/CollaborationFeed.vue")
  },
  {
    name: "screens-task-home-comp-CollaborationItem",
    path: "/screens/task/home/comp/CollaborationItem",
    component: () => import("/app/pages/screens/task/home/comp/CollaborationItem.vue")
  },
  {
    name: "screens-task-reports-comp-ProjectSection",
    path: "/screens/task/reports/comp/ProjectSection",
    component: () => import("/app/pages/screens/task/reports/comp/ProjectSection.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings",
    path: "/screens/hr-evaluation/conf/settings",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/index.vue")
  },
  {
    name: "screens-performance-job-description",
    path: "/screens/performance/job-description",
    component: () => import("/app/pages/screens/performance/job-description/index.vue")
  },
  {
    name: "screens-performance-kpiDetailStatus",
    path: "/screens/performance/kpiDetailStatus",
    meta: index6uKMj7eiSLtp7RuSXtZmu5BJuVEyLBOe4rgeDDYzLqsMeta || {},
    component: () => import("/app/pages/screens/performance/kpiDetailStatus/index.vue")
  },
  {
    name: "screens-performance-okrDetailStatus",
    path: "/screens/performance/okrDetailStatus",
    meta: indexSlAh_eU6tglaLtRWcQGMLaOBB6z6aSGjfFO_457ZldOm4Meta || {},
    component: () => import("/app/pages/screens/performance/okrDetailStatus/index.vue")
  },
  {
    name: "screens-task-reports-comp-FeedbackComment",
    path: "/screens/task/reports/comp/FeedbackComment",
    component: () => import("/app/pages/screens/task/reports/comp/FeedbackComment.vue")
  },
  {
    name: "screens-hr-evaluation-results-report",
    path: "/screens/hr-evaluation/results/report",
    component: () => import("/app/pages/screens/hr-evaluation/results/report/index.vue")
  },
  {
    name: "screens-pa-dashboard-comp-YearlyTrendChart",
    path: "/screens/pa/dashboard/comp/YearlyTrendChart",
    component: () => import("/app/pages/screens/pa/dashboard/comp/YearlyTrendChart.vue")
  },
  {
    name: "screens-pa-dataset-comp-DatasetDetailModal",
    path: "/screens/pa/dataset/comp/DatasetDetailModal",
    component: () => import("/app/pages/screens/pa/dataset/comp/DatasetDetailModal.vue")
  },
  {
    name: "screens-performance-kpi-comp-KpiFormFields",
    path: "/screens/performance/kpi/comp/KpiFormFields",
    component: () => import("/app/pages/screens/performance/kpi/comp/KpiFormFields.vue")
  },
  {
    name: "screens-performance-kpi-comp-KpiTermNotice",
    path: "/screens/performance/kpi/comp/KpiTermNotice",
    component: () => import("/app/pages/screens/performance/kpi/comp/KpiTermNotice.vue")
  },
  {
    name: "screens-performance-kpi-comp-OkrFormFields",
    path: "/screens/performance/kpi/comp/OkrFormFields",
    component: () => import("/app/pages/screens/performance/kpi/comp/OkrFormFields.vue")
  },
  {
    name: "screens-performance-status-comp-PageHeader",
    path: "/screens/performance/status/comp/PageHeader",
    component: () => import("/app/pages/screens/performance/status/comp/PageHeader.vue")
  },
  {
    name: "screens-task-home-comp-CollaborationHeader",
    path: "/screens/task/home/comp/CollaborationHeader",
    component: () => import("/app/pages/screens/task/home/comp/CollaborationHeader.vue")
  },
  {
    name: "screens-common-config-ai-token-config",
    path: "/screens/common/config/ai-token-config",
    meta: indexnTIS0RVzAAsew3ju_4571sfnRYK69XugrNvA_45e0R8UBFoMeta || {},
    component: () => import("/app/pages/screens/common/config/ai-token-config/index.vue")
  },
  {
    name: "screens-pa-dashboard-comp-MonthlyTrendChart",
    path: "/screens/pa/dashboard/comp/MonthlyTrendChart",
    component: () => import("/app/pages/screens/pa/dashboard/comp/MonthlyTrendChart.vue")
  },
  {
    name: "screens-pa-dashboard-comp-OrganizationTable",
    path: "/screens/pa/dashboard/comp/OrganizationTable",
    component: () => import("/app/pages/screens/pa/dashboard/comp/OrganizationTable.vue")
  },
  {
    name: "screens-task-home-comp-CollaborationSidebar",
    path: "/screens/task/home/comp/CollaborationSidebar",
    component: () => import("/app/pages/screens/task/home/comp/CollaborationSidebar.vue")
  },
  {
    name: "screens-common-config-comp-info-config",
    path: "/screens/common/config/comp-info-config",
    meta: indexoj_vlEvWTgFsZeqwiyZuvqbrSM22h7on2_KfpiL22ScMeta || {},
    component: () => import("/app/pages/screens/common/config/comp-info-config/index.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-ability",
    path: "/screens/hr-evaluation/evaluate/ability",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/ability/index.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform",
    path: "/screens/hr-evaluation/evaluate/perform",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/index.vue")
  },
  {
    name: "screens-hr-evaluation-progress-targets",
    path: "/screens/hr-evaluation/progress/targets",
    component: () => import("/app/pages/screens/hr-evaluation/progress/targets/index.vue")
  },
  {
    name: "screens-hr-evaluation-results-row-data",
    path: "/screens/hr-evaluation/results/row-data",
    component: () => import("/app/pages/screens/hr-evaluation/results/row-data/index.vue")
  },
  {
    name: "screens-hr-mgt-hr-monitoring-user-tree",
    path: "/screens/hr-mgt/hr-monitoring/user-tree",
    meta: indexpUBU9G14TzrfyzN5PlfpsBW3MfNajC9v5vNaYAQEFsYMeta || {},
    component: () => import("/app/pages/screens/hr-mgt/hr-monitoring/user-tree/index.vue")
  },
  {
    name: "screens-org-evaluation-org-eval-adjust",
    path: "/screens/org-evaluation/org-eval-adjust",
    meta: indexi9Regnh1BQxVd9j6Fnh_45xdTPHJKDMQTmVsHSJxN5xZwMeta || {},
    component: () => import("/app/pages/screens/org-evaluation/org-eval-adjust/index.vue")
  },
  {
    name: "screens-org-evaluation-org-eval-result",
    path: "/screens/org-evaluation/org-eval-result",
    meta: indexKihE0KziUThw_7MNtzDiNLFU2XaT4dx2GBhbJOssUDAMeta || {},
    component: () => import("/app/pages/screens/org-evaluation/org-eval-result/index.vue")
  },
  {
    name: "screens-org-performance-org-kpi-actual",
    path: "/screens/org-performance/org-kpi-actual",
    meta: indexlMePBM4DVLKW_IjHA0ZV1Jy_45fZknTMga0f990LzByzoMeta || {},
    component: () => import("/app/pages/screens/org-performance/org-kpi-actual/index.vue")
  },
  {
    name: "screens-performance-kpi-comp-PlanStatusLabel",
    path: "/screens/performance/kpi/comp/PlanStatusLabel",
    component: () => import("/app/pages/screens/performance/kpi/comp/PlanStatusLabel.vue")
  },
  {
    name: "screens-task-reports-comp-modals-ReportModal",
    path: "/screens/task/reports/comp/modals/ReportModal",
    component: () => import("/app/pages/screens/task/reports/comp/modals/ReportModal.vue")
  },
  {
    name: "screens-task-reports-comp-PlanContentSection",
    path: "/screens/task/reports/comp/PlanContentSection",
    component: () => import("/app/pages/screens/task/reports/comp/PlanContentSection.vue")
  },
  {
    name: "screens-hr-evaluation-objections-review",
    path: "/screens/hr-evaluation/objections/review",
    component: () => import("/app/pages/screens/hr-evaluation/objections/review/index.vue")
  },
  {
    name: "screens-hr-evaluation-objections-setting",
    path: "/screens/hr-evaluation/objections/setting",
    component: () => import("/app/pages/screens/hr-evaluation/objections/setting/index.vue")
  },
  {
    name: "screens-hr-mgt-hr-monitoring-user-detail",
    path: "/screens/hr-mgt/hr-monitoring/user-detail",
    meta: indexyPDXg9kNDEfSszxMB3RjPDdjgpTrlj5Z32IngBajFRoMeta || {},
    component: () => import("/app/pages/screens/hr-mgt/hr-monitoring/user-detail/index.vue")
  },
  {
    name: "screens-onboarding-onboarding-config-faq",
    path: "/screens/onboarding/onboarding-config/faq",
    meta: indexLaOFxmmw5wy8ecJTzN1UYKUz_xmS5FV7eWvU_45AU0mB4Meta || {},
    component: () => import("/app/pages/screens/onboarding/onboarding-config/faq/index.vue")
  },
  {
    name: "screens-org-evaluation-org-eval-etc-item",
    path: "/screens/org-evaluation/org-eval-etc-item",
    meta: index7xSbuadNXnrJwBuIgA_zcs0C236POldY9YL4ClXHwpoMeta || {},
    component: () => import("/app/pages/screens/org-evaluation/org-eval-etc-item/index.vue")
  },
  {
    name: "screens-task-reports-comp-ActualContentSection",
    path: "/screens/task/reports/comp/ActualContentSection",
    component: () => import("/app/pages/screens/task/reports/comp/ActualContentSection.vue")
  },
  {
    name: "mobile-eval-evaluation-results-objections",
    path: "/mobile/eval/evaluation-results/objections",
    meta: indexlg3TefY_NgZblD45XoD93SE6_45i8jVmtdHqCTMbyEzP0Meta || {},
    component: () => import("/app/pages/mobile/eval/evaluation-results/objections/index.vue")
  },
  {
    name: "screens-common-community-notice-board-qna",
    path: "/screens/common/community/notice-board/qna",
    meta: indexRxP6s1UfLkoyf4a8EzZ_p1D_45dzTTJE7WKtVAEKV1jagMeta || {},
    component: () => import("/app/pages/screens/common/community/notice-board/qna/index.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-ability",
    path: "/screens/hr-evaluation/calculation/ability",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/ability/index.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-perform",
    path: "/screens/hr-evaluation/calculation/perform",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/perform/index.vue")
  },
  {
    name: "screens-hr-evaluation-progress-evaluators",
    path: "/screens/hr-evaluation/progress/evaluators",
    component: () => import("/app/pages/screens/hr-evaluation/progress/evaluators/index.vue")
  },
  {
    name: "screens-onboarding-onboarding-base-config",
    path: "/screens/onboarding/onboarding-base-config",
    meta: indexCSFmCPVUN1p7KwLr0lORvOKbpCA7_45hVUO4VMZqkM43YMeta || {},
    component: () => import("/app/pages/screens/onboarding/onboarding-base-config/index.vue")
  },
  {
    name: "screens-pa-dashboard-comp-AllMemberDatasetModal",
    path: "/screens/pa/dashboard/comp/AllMemberDatasetModal",
    component: () => import("/app/pages/screens/pa/dashboard/comp/AllMemberDatasetModal.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-KpiCopyMenu",
    path: "/screens/performance/kpi/comp/modals/KpiCopyMenu",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/KpiCopyMenu.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-KrLinkModal",
    path: "/screens/performance/kpi/comp/modals/KrLinkModal",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/KrLinkModal.vue")
  },
  {
    name: "screens-task-reports-comp-modals-AiSummaryModal",
    path: "/screens/task/reports/comp/modals/AiSummaryModal",
    component: () => import("/app/pages/screens/task/reports/comp/modals/AiSummaryModal.vue")
  },
  {
    name: "screens-task-reports-comp-modals-PmsDetailModal",
    path: "/screens/task/reports/comp/modals/PmsDetailModal",
    component: () => import("/app/pages/screens/task/reports/comp/modals/PmsDetailModal.vue")
  },
  {
    name: "screens-task-reports-comp-modals-ReportOkrModal",
    path: "/screens/task/reports/comp/modals/ReportOkrModal",
    component: () => import("/app/pages/screens/task/reports/comp/modals/ReportOkrModal.vue")
  },
  {
    name: "mobile-eval-evaluation-results-objections-submit",
    path: "/mobile/eval/evaluation-results/objections/submit",
    meta: submitrdW8UuuyiHvwiptSZnMUpPY12PKqWbrJNHcyHbhCJqAMeta || {},
    component: () => import("/app/pages/mobile/eval/evaluation-results/objections/submit.vue")
  },
  {
    name: "screens-hr-evaluation-adjustment-comp-PageHeader",
    path: "/screens/hr-evaluation/adjustment/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/adjustment/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-common-PageHeader",
    path: "/screens/hr-evaluation/evaluate/common/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/common/PageHeader.vue")
  },
  {
    name: "screens-onboarding-onboarding-config-goods",
    path: "/screens/onboarding/onboarding-config/goods",
    meta: indexwyULGFPbKTsU1XKIHL4dgspl1y_450B7X_45yh5_MrQASpEMeta || {},
    component: () => import("/app/pages/screens/onboarding/onboarding-config/goods/index.vue")
  },
  {
    name: "screens-org-evaluation-org-eval-monitoring",
    path: "/screens/org-evaluation/org-eval-monitoring",
    meta: indexnt1UX9TbY2dWnD5DRvz4JgggWiJWTMBxFv7EpobAqKkMeta || {},
    component: () => import("/app/pages/screens/org-evaluation/org-eval-monitoring/index.vue")
  },
  {
    name: "screens-org-performance-org-kpi-monitoring",
    path: "/screens/org-performance/org-kpi-monitoring",
    meta: indexeXPgyLc7AsswHPMpKk7iucbw6c3uow9npdz1_tY3ZOkMeta || {},
    component: () => import("/app/pages/screens/org-performance/org-kpi-monitoring/index.vue")
  },
  {
    name: "screens-pa-dashboard-comp-MemberPerformanceChart",
    path: "/screens/pa/dashboard/comp/MemberPerformanceChart",
    component: () => import("/app/pages/screens/pa/dashboard/comp/MemberPerformanceChart.vue")
  },
  {
    name: "screens-pa-dashboard-comp-MemberPerformanceModal",
    path: "/screens/pa/dashboard/comp/MemberPerformanceModal",
    component: () => import("/app/pages/screens/pa/dashboard/comp/MemberPerformanceModal.vue")
  },
  {
    name: "screens-performance-kpi-comp-KpiActualTabContent",
    path: "/screens/performance/kpi/comp/KpiActualTabContent",
    component: () => import("/app/pages/screens/performance/kpi/comp/KpiActualTabContent.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-FeedbackCard",
    path: "/screens/performance/kpi/comp/modals/FeedbackCard",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/FeedbackCard.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-KpiLinkModal",
    path: "/screens/performance/kpi/comp/modals/KpiLinkModal",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/KpiLinkModal.vue")
  },
  {
    name: "screens-common-community-notice-board-board",
    path: "/screens/common/community/notice-board/board",
    meta: indexuJ2uRwbvOI_45AVvcs5MJGcXtFDbWMsAhFsz9rAwLijGkMeta || {},
    component: () => import("/app/pages/screens/common/community/notice-board/board/index.vue")
  },
  {
    name: "screens-org-evaluation-org-eval-calculation",
    path: "/screens/org-evaluation/org-eval-calculation",
    meta: index_au2RsUiwZ7F8ZdPN5u0XtFeAjbEJr0Q5BtwizrGL2MMeta || {},
    component: () => import("/app/pages/screens/org-evaluation/org-eval-calculation/index.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-FeedbackModal",
    path: "/screens/performance/kpi/comp/modals/FeedbackModal",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/FeedbackModal.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-KrDetailModal",
    path: "/screens/performance/kpi/comp/modals/KrDetailModal",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/KrDetailModal.vue")
  },
  {
    name: "screens-performance-kpi-comp-PerformanceGoalTable",
    path: "/screens/performance/kpi/comp/PerformanceGoalTable",
    component: () => import("/app/pages/screens/performance/kpi/comp/PerformanceGoalTable.vue")
  },
  {
    name: "screens-task-reports-comp-AiSummaryConfirmMessage",
    path: "/screens/task/reports/comp/AiSummaryConfirmMessage",
    component: () => import("/app/pages/screens/task/reports/comp/AiSummaryConfirmMessage.vue")
  },
  {
    name: "screens-task-reports-comp-modals-ActivityAddModal",
    path: "/screens/task/reports/comp/modals/ActivityAddModal",
    component: () => import("/app/pages/screens/task/reports/comp/modals/ActivityAddModal.vue")
  },
  {
    name: "screens-common-community-notice-board-notice",
    path: "/screens/common/community/notice-board/notice",
    meta: indexqhFx9bmuFITGGQfk7as0okHgEX0ddDVyTQzk2_45bDjw8Meta || {},
    component: () => import("/app/pages/screens/common/community/notice-board/notice/index.vue")
  },
  {
    name: "screens-common-config-org-performnace-config",
    path: "/screens/common/config/org-performnace-config",
    meta: indexkslq9wAoNX__sI_45FXVCvvcJ5H_45u_QpDMZhilegbuXY8Meta || {},
    component: () => import("/app/pages/screens/common/config/org-performnace-config/index.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-scale",
    path: "/screens/hr-evaluation/conf/basis/grade-scale",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-scale/index.vue")
  },
  {
    name: "screens-hr-evaluation-conf-targets-comp-PageHeader",
    path: "/screens/hr-evaluation/conf/targets/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/conf/targets/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-common-SearchFilter",
    path: "/screens/hr-evaluation/evaluate/common/SearchFilter",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/common/SearchFilter.vue")
  },
  {
    name: "screens-hr-evaluation-results-results-view-gbnCd",
    path: "/screens/hr-evaluation/results/results-view/:gbnCd()",
    component: () => import("/app/pages/screens/hr-evaluation/results/results-view/[gbnCd].vue")
  },
  {
    name: "screens-org-evaluation-org-evaluation-config",
    path: "/screens/org-evaluation/org-evaluation-config",
    meta: indexotfCtfQX6AV_JLLJYsgkcKM_454gT6CYyQPbO_sMVaKigMeta || {},
    component: () => import("/app/pages/screens/org-evaluation/org-evaluation-config/index.vue")
  },
  {
    name: "screens-performance-kpi-comp-KpiPropertyTabContent",
    path: "/screens/performance/kpi/comp/KpiPropertyTabContent",
    component: () => import("/app/pages/screens/performance/kpi/comp/KpiPropertyTabContent.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-ActualAddModal",
    path: "/screens/performance/kpi/comp/modals/ActualAddModal",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/ActualAddModal.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-KrCopyMoveMenu",
    path: "/screens/performance/kpi/comp/modals/KrCopyMoveMenu",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/KrCopyMoveMenu.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-OkrSelectModal",
    path: "/screens/performance/kpi/comp/modals/OkrSelectModal",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/OkrSelectModal.vue")
  },
  {
    name: "screens-task-reports-comp-modals-ReportConfigModal",
    path: "/screens/task/reports/comp/modals/ReportConfigModal",
    component: () => import("/app/pages/screens/task/reports/comp/modals/ReportConfigModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-PageHeader",
    path: "/screens/hr-evaluation/conf/settings/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/PageHeader.vue")
  },
  {
    name: "screens-onboarding-onboarding-config-schedule",
    path: "/screens/onboarding/onboarding-config/schedule",
    meta: indexMTAOg5kPxClSzqWgmLaPRNG06nkoSkmR__Q5_45nuszogMeta || {},
    component: () => import("/app/pages/screens/onboarding/onboarding-config/schedule/index.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-KpiSettingModal",
    path: "/screens/performance/kpi/comp/modals/KpiSettingModal",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/KpiSettingModal.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-KrCascadingNode",
    path: "/screens/performance/kpi/comp/modals/KrCascadingNode",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/KrCascadingNode.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-KrCascadingTree",
    path: "/screens/performance/kpi/comp/modals/KrCascadingTree",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/KrCascadingTree.vue")
  },
  {
    name: "screens-performance-kpiDetailStatus-comp-PageHeader",
    path: "/screens/performance/kpiDetailStatus/comp/PageHeader",
    component: () => import("/app/pages/screens/performance/kpiDetailStatus/comp/PageHeader.vue")
  },
  {
    name: "screens-performance-okrDetailStatus-comp-PageHeader",
    path: "/screens/performance/okrDetailStatus/comp/PageHeader",
    component: () => import("/app/pages/screens/performance/okrDetailStatus/comp/PageHeader.vue")
  },
  {
    name: "screens-common-community-notice-board-bulletin",
    path: "/screens/common/community/notice-board/bulletin",
    meta: index22fG5JF3T0E_2U3sM2Ke1eE6NfGqsotaqfxR55iFPiwMeta || {},
    component: () => import("/app/pages/screens/common/community/notice-board/bulletin/index.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerIdpPanel",
    path: "/screens/dashboard/manager/components/ManagerIdpPanel",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerIdpPanel.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerKpiPanel",
    path: "/screens/dashboard/manager/components/ManagerKpiPanel",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerKpiPanel.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerPlanList",
    path: "/screens/dashboard/manager/components/ManagerPlanList",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerPlanList.vue")
  },
  {
    name: "screens-hr-evaluation-conf-targets-comp-EmployeeCard",
    path: "/screens/hr-evaluation/conf/targets/comp/EmployeeCard",
    component: () => import("/app/pages/screens/hr-evaluation/conf/targets/comp/EmployeeCard.vue")
  },
  {
    name: "screens-hr-evaluation-description-job-template",
    path: "/screens/hr-evaluation/description/job-template",
    component: () => import("/app/pages/screens/hr-evaluation/description/job-template/index.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-common-EvalTargetList",
    path: "/screens/hr-evaluation/evaluate/common/EvalTargetList",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/common/EvalTargetList.vue")
  },
  {
    name: "screens-hr-evaluation-results-report-comp-PageHeader",
    path: "/screens/hr-evaluation/results/report/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/results/report/comp/PageHeader.vue")
  },
  {
    name: "screens-task-home-comp-modals-CollaborationTaskModal",
    path: "/screens/task/home/comp/modals/CollaborationTaskModal",
    component: () => import("/app/pages/screens/task/home/comp/modals/CollaborationTaskModal.vue")
  },
  {
    name: "screens-task-reports-comp-modals-ActivityContentCell",
    path: "/screens/task/reports/comp/modals/ActivityContentCell",
    component: () => import("/app/pages/screens/task/reports/comp/modals/ActivityContentCell.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerPlanPanel",
    path: "/screens/dashboard/manager/components/ManagerPlanPanel",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerPlanPanel.vue")
  },
  {
    name: "screens-hr-evaluation-objections-review-objectionId",
    path: "/screens/hr-evaluation/objections/review/:objectionId()",
    component: () => import("/app/pages/screens/hr-evaluation/objections/review/[objectionId].vue")
  },
  {
    name: "screens-hr-evaluation-results-total-result-view",
    path: "/screens/hr-evaluation/results/total-result-view",
    component: () => import("/app/pages/screens/hr-evaluation/results/total-result-view/index.vue")
  },
  {
    name: "screens-onboarding-onboarding-config-advertiese",
    path: "/screens/onboarding/onboarding-config/advertiese",
    meta: indexHL3qXv6RjkjPgDl9NTkOX0EhK8fHyN842a7zMhwPiTAMeta || {},
    component: () => import("/app/pages/screens/onboarding/onboarding-config/advertiese/index.vue")
  },
  {
    name: "screens-pa-dashboard-comp-OrganizationComparisonChart",
    path: "/screens/pa/dashboard/comp/OrganizationComparisonChart",
    component: () => import("/app/pages/screens/pa/dashboard/comp/OrganizationComparisonChart.vue")
  },
  {
    name: "screens-task-reports-comp-modals-AiSummaryEditorBlock",
    path: "/screens/task/reports/comp/modals/AiSummaryEditorBlock",
    component: () => import("/app/pages/screens/task/reports/comp/modals/AiSummaryEditorBlock.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerGanttChart",
    path: "/screens/dashboard/manager/components/ManagerGanttChart",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerGanttChart.vue")
  },
  {
    name: "screens-hr-evaluation-conf-targets-comp-evalTargetList",
    path: "/screens/hr-evaluation/conf/targets/comp/evalTargetList",
    component: () => import("/app/pages/screens/hr-evaluation/conf/targets/comp/evalTargetList.vue")
  },
  {
    name: "screens-hr-evaluation-my-results-comp-EvaluationResult",
    path: "/screens/hr-evaluation/my-results/comp/EvaluationResult",
    component: () => import("/app/pages/screens/hr-evaluation/my-results/comp/EvaluationResult.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-DistributeKpiModal",
    path: "/screens/performance/kpi/comp/modals/DistributeKpiModal",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/DistributeKpiModal.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerActivityRow",
    path: "/screens/dashboard/manager/components/ManagerActivityRow",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerActivityRow.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerHrEvalPanel",
    path: "/screens/dashboard/manager/components/ManagerHrEvalPanel",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerHrEvalPanel.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerOrgTreeItem",
    path: "/screens/dashboard/manager/components/ManagerOrgTreeItem",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerOrgTreeItem.vue")
  },
  {
    name: "screens-dashboard-personal-components-PersonalPerfPanel",
    path: "/screens/dashboard/personal/components/PersonalPerfPanel",
    component: () => import("/app/pages/screens/dashboard/personal/components/PersonalPerfPanel.vue")
  },
  {
    name: "screens-dashboard-personal-components-PersonalWorkPanel",
    path: "/screens/dashboard/personal/components/PersonalWorkPanel",
    component: () => import("/app/pages/screens/dashboard/personal/components/PersonalWorkPanel.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-org-calculation",
    path: "/screens/hr-evaluation/calculation/org-calculation",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/org-calculation/index.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-items",
    path: "/screens/hr-evaluation/conf/basis/competency-items",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-items/index.vue")
  },
  {
    name: "screens-hr-evaluation-description-job-description",
    path: "/screens/hr-evaluation/description/job-description",
    component: () => import("/app/pages/screens/hr-evaluation/description/job-description/index.vue")
  },
  {
    name: "screens-onboarding-onboarding-config-welcome-mail",
    path: "/screens/onboarding/onboarding-config/welcome-mail",
    meta: indexYPuXD_45ZeqqpgFJTC0XA146PX3VN7gR6uPutCf1hRfVQMeta || {},
    component: () => import("/app/pages/screens/onboarding/onboarding-config/welcome-mail/index.vue")
  },
  {
    name: "screens-project-monitoring-all-project-monitoring",
    path: "/screens/project/monitoring/all-project-monitoring",
    meta: indexZrisRCuSB18Fn5ysliXZGAWUdrTpYbuVggQTmMq8__4Meta || {},
    component: () => import("/app/pages/screens/project/monitoring/all-project-monitoring/index.vue")
  },
  {
    name: "screens-task-reports-comp-modals-ReportKpiReadonlyModal",
    path: "/screens/task/reports/comp/modals/ReportKpiReadonlyModal",
    component: () => import("/app/pages/screens/task/reports/comp/modals/ReportKpiReadonlyModal.vue")
  },
  {
    name: "screens-common-config-auth-config-menu-auth-config",
    path: "/screens/common/config/auth-config/menu-auth-config",
    meta: indexe0US_VbAf9G0jvBovhrcF8u2_45u6F0iZUVOn9KH7VptEMeta || {},
    component: () => import("/app/pages/screens/common/config/auth-config/menu-auth-config/index.vue")
  },
  {
    name: "screens-common-config-auth-config-user-auth-config",
    path: "/screens/common/config/auth-config/user-auth-config",
    meta: index_45AHP5lh18BLJrEjmmwT0781sUqLStvB4QAKQsQyCFhYMeta || {},
    component: () => import("/app/pages/screens/common/config/auth-config/user-auth-config/index.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerJobDescPanel",
    path: "/screens/dashboard/manager/components/ManagerJobDescPanel",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerJobDescPanel.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerOrgTreePanel",
    path: "/screens/dashboard/manager/components/ManagerOrgTreePanel",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerOrgTreePanel.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-performance-items",
    path: "/screens/hr-evaluation/conf/basis/performance-items",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/performance-items/index.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-InsaWizardModal",
    path: "/screens/hr-evaluation/conf/settings/comp/InsaWizardModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/InsaWizardModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-targets-comp-evalTargetDetail",
    path: "/screens/hr-evaluation/conf/targets/comp/evalTargetDetail",
    component: () => import("/app/pages/screens/hr-evaluation/conf/targets/comp/evalTargetDetail.vue")
  },
  {
    name: "screens-hr-evaluation-conf-targets-comp-modal-GuideModal",
    path: "/screens/hr-evaluation/conf/targets/comp/modal/GuideModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/targets/comp/modal/GuideModal.vue")
  },
  {
    name: "screens-onboarding-onboarding-config-feedback-item",
    path: "/screens/onboarding/onboarding-config/feedback-item",
    meta: indexCLl0lt6kbJroRsaYQpqBmkYgzWnK_45_455l6Hr_45NkFxfZ4Meta || {},
    component: () => import("/app/pages/screens/onboarding/onboarding-config/feedback-item/index.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-AgreementReasonModal",
    path: "/screens/performance/kpi/comp/modals/AgreementReasonModal",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/AgreementReasonModal.vue")
  },
  {
    name: "screens-project-monitoring-dept-project-monitoring",
    path: "/screens/project/monitoring/dept-project-monitoring",
    meta: indexU9NsEQNlhq9iZ7PkCEWNHoGnkKqW_uO9kNKOqVcODqQMeta || {},
    component: () => import("/app/pages/screens/project/monitoring/dept-project-monitoring/index.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerActivityPanel",
    path: "/screens/dashboard/manager/components/ManagerActivityPanel",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerActivityPanel.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerCalendarPanel",
    path: "/screens/dashboard/manager/components/ManagerCalendarPanel",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerCalendarPanel.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerPerfStmtPanel",
    path: "/screens/dashboard/manager/components/ManagerPerfStmtPanel",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerPerfStmtPanel.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerPlanFilterBar",
    path: "/screens/dashboard/manager/components/ManagerPlanFilterBar",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerPlanFilterBar.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerTimelineModal",
    path: "/screens/dashboard/manager/components/ManagerTimelineModal",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerTimelineModal.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerTimelinePanel",
    path: "/screens/dashboard/manager/components/ManagerTimelinePanel",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerTimelinePanel.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-other-items",
    path: "/screens/hr-evaluation/calculation/total/other-items",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/other-items/index.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-distribution",
    path: "/screens/hr-evaluation/conf/basis/grade-distribution",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/index.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-common-comp-AiHelperButton",
    path: "/screens/hr-evaluation/evaluate/common/comp/AiHelperButton",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/common/comp/AiHelperButton.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-ResultEvalTab",
    path: "/screens/hr-evaluation/evaluate/perform/comp/ResultEvalTab",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/ResultEvalTab.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-AgreementContentModal",
    path: "/screens/performance/kpi/comp/modals/AgreementContentModal",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/AgreementContentModal.vue")
  },
  {
    name: "screens-performance-kpi-comp-modals-AgreementHistoryModal",
    path: "/screens/performance/kpi/comp/modals/AgreementHistoryModal",
    component: () => import("/app/pages/screens/performance/kpi/comp/modals/AgreementHistoryModal.vue")
  },
  {
    name: "screens-project-monitoring-issue-project-monitoring",
    path: "/screens/project/monitoring/issue-project-monitoring",
    meta: indexTnHx69BmQjzI1Mdrr_j_ubbTrIsydmukBGUgy5ye8j4Meta || {},
    component: () => import("/app/pages/screens/project/monitoring/issue-project-monitoring/index.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerHrEvalTreeItem",
    path: "/screens/dashboard/manager/components/ManagerHrEvalTreeItem",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerHrEvalTreeItem.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-LoadSettingsModal",
    path: "/screens/hr-evaluation/conf/settings/comp/LoadSettingsModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/LoadSettingsModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-description-status",
    path: "/screens/hr-evaluation/description/description-status",
    component: () => import("/app/pages/screens/hr-evaluation/description/description-status/index.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-ability-comp-PrevEvalResult",
    path: "/screens/hr-evaluation/evaluate/ability/comp/PrevEvalResult",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/ability/comp/PrevEvalResult.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-common-comp-modals-IdpModal",
    path: "/screens/hr-evaluation/evaluate/common/comp/modals/IdpModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/common/comp/modals/IdpModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-modals-KrModal",
    path: "/screens/hr-evaluation/evaluate/perform/comp/modals/KrModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/KrModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-PerformEvalTab",
    path: "/screens/hr-evaluation/evaluate/perform/comp/PerformEvalTab",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvalTab.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-PrevEvalResult",
    path: "/screens/hr-evaluation/evaluate/perform/comp/PrevEvalResult",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/PrevEvalResult.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-ProcessEvalTab",
    path: "/screens/hr-evaluation/evaluate/perform/comp/ProcessEvalTab",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/ProcessEvalTab.vue")
  },
  {
    name: "screens-hr-evaluation-results-report-comp-widgets-widget01",
    path: "/screens/hr-evaluation/results/report/comp/widgets/widget01",
    component: () => import("/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget01.vue")
  },
  {
    name: "screens-hr-evaluation-results-report-comp-widgets-widget02",
    path: "/screens/hr-evaluation/results/report/comp/widgets/widget02",
    component: () => import("/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget02.vue")
  },
  {
    name: "screens-hr-evaluation-results-report-comp-widgets-widget03",
    path: "/screens/hr-evaluation/results/report/comp/widgets/widget03",
    component: () => import("/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget03.vue")
  },
  {
    name: "screens-hr-evaluation-results-report-comp-widgets-widget04",
    path: "/screens/hr-evaluation/results/report/comp/widgets/widget04",
    component: () => import("/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget04.vue")
  },
  {
    name: "screens-hr-evaluation-results-report-comp-widgets-widget05",
    path: "/screens/hr-evaluation/results/report/comp/widgets/widget05",
    component: () => import("/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget05.vue")
  },
  {
    name: "screens-hr-evaluation-results-report-comp-widgets-widget06",
    path: "/screens/hr-evaluation/results/report/comp/widgets/widget06",
    component: () => import("/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget06.vue")
  },
  {
    name: "screens-hr-evaluation-results-report-comp-widgets-widget07",
    path: "/screens/hr-evaluation/results/report/comp/widgets/widget07",
    component: () => import("/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget07.vue")
  },
  {
    name: "screens-hr-evaluation-results-report-comp-widgets-widget08",
    path: "/screens/hr-evaluation/results/report/comp/widgets/widget08",
    component: () => import("/app/pages/screens/hr-evaluation/results/report/comp/widgets/widget08.vue")
  },
  {
    name: "screens-hr-evaluation-results-results-view-comp-PageHeader",
    path: "/screens/hr-evaluation/results/results-view/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/results/results-view/comp/PageHeader.vue")
  },
  {
    name: "screens-onboarding-onboarding-config-feedback-result",
    path: "/screens/onboarding/onboarding-config/feedback-result",
    meta: indexv3VBZTXNt3bw9_45wg4s9_456pC9_45WQf0Eqg9a_45LMBYZUoQMeta || {},
    component: () => import("/app/pages/screens/onboarding/onboarding-config/feedback-result/index.vue")
  },
  {
    name: "screens-common-config-password-change-password-change",
    path: "/screens/common/config/password-change/password-change",
    meta: indexTJpfuO_45WDuMwcg72WzNdUDj8QktJHzszNBjoINDQX20Meta || {},
    component: () => import("/app/pages/screens/common/config/password-change/password-change/index.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerEvalResultModal",
    path: "/screens/dashboard/manager/components/ManagerEvalResultModal",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerEvalResultModal.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerImportPlanModal",
    path: "/screens/dashboard/manager/components/ManagerImportPlanModal",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerImportPlanModal.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerKrTimelineModal",
    path: "/screens/dashboard/manager/components/ManagerKrTimelineModal",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerKrTimelineModal.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerPerformanceTabs",
    path: "/screens/dashboard/manager/components/ManagerPerformanceTabs",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerPerformanceTabs.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerTaskDetailPanel",
    path: "/screens/dashboard/manager/components/ManagerTaskDetailPanel",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerTaskDetailPanel.vue")
  },
  {
    name: "screens-dashboard-personal-components-PersonalCalendarPanel",
    path: "/screens/dashboard/personal/components/PersonalCalendarPanel",
    component: () => import("/app/pages/screens/dashboard/personal/components/PersonalCalendarPanel.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-perform-comp-cards-KrCard",
    path: "/screens/hr-evaluation/calculation/perform/comp/cards/KrCard",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/perform/comp/cards/KrCard.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-results",
    path: "/screens/hr-evaluation/calculation/total/total-results",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-results/index.vue")
  },
  {
    name: "screens-hr-evaluation-conf-targets-comp-modal-CapaItemModal",
    path: "/screens/hr-evaluation/conf/targets/comp/modal/CapaItemModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/targets/comp/modal/CapaItemModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-modals-KpiModal",
    path: "/screens/hr-evaluation/evaluate/perform/comp/modals/KpiModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/KpiModal.vue")
  },
  {
    name: "screens-hr-evaluation-progress-evaluators-comp-PreviewModal",
    path: "/screens/hr-evaluation/progress/evaluators/comp/PreviewModal",
    component: () => import("/app/pages/screens/hr-evaluation/progress/evaluators/comp/PreviewModal.vue")
  },
  {
    name: "screens-hr-evaluation-results-results-view-comp-ResultTable",
    path: "/screens/hr-evaluation/results/results-view/comp/ResultTable",
    component: () => import("/app/pages/screens/hr-evaluation/results/results-view/comp/ResultTable.vue")
  },
  {
    name: "screens-onboarding-onboarding-config-onboardig-target",
    path: "/screens/onboarding/onboarding-config/onboardig-target",
    meta: index1OF7ghFutqFRkj_OpyzZItedmp7T1xhsBI4l_mrWzmEMeta || {},
    component: () => import("/app/pages/screens/onboarding/onboarding-config/onboardig-target/index.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerActivityTimeline",
    path: "/screens/dashboard/manager/components/ManagerActivityTimeline",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerActivityTimeline.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerAvtPlanListModal",
    path: "/screens/dashboard/manager/components/ManagerAvtPlanListModal",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerAvtPlanListModal.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerKrCascadingModal",
    path: "/screens/dashboard/manager/components/ManagerKrCascadingModal",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerKrCascadingModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-perform-comp-cards-KpiCard",
    path: "/screens/hr-evaluation/calculation/perform/comp/cards/KpiCard",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/perform/comp/cards/KpiCard.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-dictionary",
    path: "/screens/hr-evaluation/conf/basis/competency-dictionary",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-dictionary/index.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-scale-comp-PageHeader",
    path: "/screens/hr-evaluation/conf/basis/grade-scale/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-scale/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-SettingSummaryModal",
    path: "/screens/hr-evaluation/conf/settings/comp/SettingSummaryModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/SettingSummaryModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-template",
    path: "/screens/hr-evaluation/description/performance-template",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-template/index.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-ability-comp-EvaluationHeader",
    path: "/screens/hr-evaluation/evaluate/ability/comp/EvaluationHeader",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/ability/comp/EvaluationHeader.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-common-comp-modals-GuideModal",
    path: "/screens/hr-evaluation/evaluate/common/comp/modals/GuideModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/common/comp/modals/GuideModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-modals-PlanModal",
    path: "/screens/hr-evaluation/evaluate/perform/comp/modals/PlanModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/PlanModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-tabs-FeedTabItem",
    path: "/screens/hr-evaluation/evaluate/perform/comp/tabs/FeedTabItem",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/tabs/FeedTabItem.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-tabs-PlanTabItem",
    path: "/screens/hr-evaluation/evaluate/perform/comp/tabs/PlanTabItem",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/tabs/PlanTabItem.vue")
  },
  {
    name: "screens-hr-evaluation-progress-evaluators-comp-SendMailModal",
    path: "/screens/hr-evaluation/progress/evaluators/comp/SendMailModal",
    component: () => import("/app/pages/screens/hr-evaluation/progress/evaluators/comp/SendMailModal.vue")
  },
  {
    name: "screens-common-config-ai-token-config-comp-UsageYearLineChart",
    path: "/screens/common/config/ai-token-config/comp/UsageYearLineChart",
    component: () => import("/app/pages/screens/common/config/ai-token-config/comp/UsageYearLineChart.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerActivityDateGroup",
    path: "/screens/dashboard/manager/components/ManagerActivityDateGroup",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerActivityDateGroup.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerActivityFilterBar",
    path: "/screens/dashboard/manager/components/ManagerActivityFilterBar",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerActivityFilterBar.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerActivityPlanGroup",
    path: "/screens/dashboard/manager/components/ManagerActivityPlanGroup",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerActivityPlanGroup.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerTimelineFilterBar",
    path: "/screens/dashboard/manager/components/ManagerTimelineFilterBar",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerTimelineFilterBar.vue")
  },
  {
    name: "screens-dashboard-manager-components-ManagerWeeklyReportPanel",
    path: "/screens/dashboard/manager/components/ManagerWeeklyReportPanel",
    component: () => import("/app/pages/screens/dashboard/manager/components/ManagerWeeklyReportPanel.vue")
  },
  {
    name: "screens-dashboard-personal-components-PersonalDashboardHeader",
    path: "/screens/dashboard/personal/components/PersonalDashboardHeader",
    component: () => import("/app/pages/screens/dashboard/personal/components/PersonalDashboardHeader.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-perform-comp-cards-PlanCard",
    path: "/screens/hr-evaluation/calculation/perform/comp/cards/PlanCard",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/perform/comp/cards/PlanCard.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-other-items-comp-left",
    path: "/screens/hr-evaluation/calculation/total/other-items/comp/left",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/other-items/comp/left.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-scale-comp-RatingGroup",
    path: "/screens/hr-evaluation/conf/basis/grade-scale/comp/RatingGroup",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-scale/comp/RatingGroup.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-scale-comp-RatingPanel",
    path: "/screens/hr-evaluation/conf/basis/grade-scale/comp/RatingPanel",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-scale/comp/RatingPanel.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-EvalCycleManageModal",
    path: "/screens/hr-evaluation/conf/settings/comp/EvalCycleManageModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/EvalCycleManageModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-Step07AddTargetModal",
    path: "/screens/hr-evaluation/conf/settings/comp/Step07AddTargetModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/Step07AddTargetModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-common-PerformEvalFeedbackIcon",
    path: "/screens/hr-evaluation/evaluate/common/PerformEvalFeedbackIcon",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/common/PerformEvalFeedbackIcon.vue")
  },
  {
    name: "mobile-eval-evaluation-results-objections-ObjectionDetailModal",
    path: "/mobile/eval/evaluation-results/objections/ObjectionDetailModal",
    component: () => import("/app/pages/mobile/eval/evaluation-results/objections/ObjectionDetailModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-other-items-comp-Right",
    path: "/screens/hr-evaluation/calculation/total/other-items/comp/Right",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/other-items/comp/Right.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-InsaWizardTypedBubble",
    path: "/screens/hr-evaluation/conf/settings/comp/InsaWizardTypedBubble",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/InsaWizardTypedBubble.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-tabs-KrFeedTabItem",
    path: "/screens/hr-evaluation/evaluate/perform/comp/tabs/KrFeedTabItem",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/tabs/KrFeedTabItem.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation",
    path: "/screens/hr-evaluation/calculation/total/total-calculation",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/index.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-results-comp-Left",
    path: "/screens/hr-evaluation/calculation/total/total-results/comp/Left",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-results/comp/Left.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description",
    path: "/screens/hr-evaluation/description/performance-description",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/index.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-ability-comp-modals-FeedbackIcon",
    path: "/screens/hr-evaluation/evaluate/ability/comp/modals/FeedbackIcon",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/ability/comp/modals/FeedbackIcon.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-common-comp-modals-AiHelperModal",
    path: "/screens/hr-evaluation/evaluate/common/comp/modals/AiHelperModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/common/comp/modals/AiHelperModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-common-comp-modals-FeedbackModal",
    path: "/screens/hr-evaluation/evaluate/common/comp/modals/FeedbackModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/common/comp/modals/FeedbackModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-modals-EvalRelModal",
    path: "/screens/hr-evaluation/evaluate/perform/comp/modals/EvalRelModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/EvalRelModal.vue")
  },
  {
    name: "screens-hr-evaluation-my-results-comp-modals-ObjectionListModal",
    path: "/screens/hr-evaluation/my-results/comp/modals/ObjectionListModal",
    component: () => import("/app/pages/screens/hr-evaluation/my-results/comp/modals/ObjectionListModal.vue")
  },
  {
    name: "screens-hr-evaluation-progress-evaluators-comp-EvalListTemplate",
    path: "/screens/hr-evaluation/progress/evaluators/comp/EvalListTemplate",
    component: () => import("/app/pages/screens/hr-evaluation/progress/evaluators/comp/EvalListTemplate.vue")
  },
  {
    name: "screens-hr-evaluation-results-total-result-view-comp-PageHeader",
    path: "/screens/hr-evaluation/results/total-result-view/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/results/total-result-view/comp/PageHeader.vue")
  },
  {
    name: "screens-onboarding-onboarding-config-onboardig-monitoring",
    path: "/screens/onboarding/onboarding-config/onboardig-monitoring",
    meta: index3wl5cZhkfqjzUSviyNSnmqfxzW3Q9KPc4P_WxIfIgSYMeta || {},
    component: () => import("/app/pages/screens/onboarding/onboarding-config/onboardig-monitoring/index.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-results-comp-Right",
    path: "/screens/hr-evaluation/calculation/total/total-results/comp/Right",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-results/comp/Right.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-modals-EvalItemModal",
    path: "/screens/hr-evaluation/evaluate/perform/comp/modals/EvalItemModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/EvalItemModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-modals-KpiActualList",
    path: "/screens/hr-evaluation/evaluate/perform/comp/modals/KpiActualList",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/KpiActualList.vue")
  },
  {
    name: "screens-hr-evaluation-my-results-comp-modals-AbilityEvalBarChart",
    path: "/screens/hr-evaluation/my-results/comp/modals/AbilityEvalBarChart",
    component: () => import("/app/pages/screens/hr-evaluation/my-results/comp/modals/AbilityEvalBarChart.vue")
  },
  {
    name: "screens-hr-evaluation-progress-evaluators-comp-EvalStatsTemplate",
    path: "/screens/hr-evaluation/progress/evaluators/comp/EvalStatsTemplate",
    component: () => import("/app/pages/screens/hr-evaluation/progress/evaluators/comp/EvalStatsTemplate.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-org-calculation-comp-PageHeader",
    path: "/screens/hr-evaluation/calculation/org-calculation/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/org-calculation/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-perform-comp-modals-AdjustModal",
    path: "/screens/hr-evaluation/calculation/perform/comp/modals/AdjustModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/AdjustModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-items-comp-PageHeader",
    path: "/screens/hr-evaluation/conf/basis/competency-items/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-Step07EvalDistriMngModal",
    path: "/screens/hr-evaluation/conf/settings/comp/Step07EvalDistriMngModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/Step07EvalDistriMngModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-Step07GrpUserAssignModal",
    path: "/screens/hr-evaluation/conf/settings/comp/Step07GrpUserAssignModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/Step07GrpUserAssignModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-job-description-comp-PageHeader",
    path: "/screens/hr-evaluation/description/job-description/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/description/job-description/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-ability-comp-AbilityEvaluationCell",
    path: "/screens/hr-evaluation/evaluate/ability/comp/AbilityEvaluationCell",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/ability/comp/AbilityEvaluationCell.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-modals-KrFeedbackList",
    path: "/screens/hr-evaluation/evaluate/perform/comp/modals/KrFeedbackList",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/KrFeedbackList.vue")
  },
  {
    name: "screens-hr-evaluation-my-results-comp-modals-EvalOpinionViewModal",
    path: "/screens/hr-evaluation/my-results/comp/modals/EvalOpinionViewModal",
    component: () => import("/app/pages/screens/hr-evaluation/my-results/comp/modals/EvalOpinionViewModal.vue")
  },
  {
    name: "screens-hr-evaluation-my-results-comp-modals-ObjectionDetailModal",
    path: "/screens/hr-evaluation/my-results/comp/modals/ObjectionDetailModal",
    component: () => import("/app/pages/screens/hr-evaluation/my-results/comp/modals/ObjectionDetailModal.vue")
  },
  {
    name: "screens-hr-evaluation-my-results-comp-modals-ObjectionSubmitModal",
    path: "/screens/hr-evaluation/my-results/comp/modals/ObjectionSubmitModal",
    component: () => import("/app/pages/screens/hr-evaluation/my-results/comp/modals/ObjectionSubmitModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-performance-items-comp-PageHeader",
    path: "/screens/hr-evaluation/conf/basis/performance-items/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-Step07CapaItemPickerModal",
    path: "/screens/hr-evaluation/conf/settings/comp/Step07CapaItemPickerModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/Step07CapaItemPickerModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-ability-comp-AbilityEvaluationTable",
    path: "/screens/hr-evaluation/evaluate/ability/comp/AbilityEvaluationTable",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/ability/comp/AbilityEvaluationTable.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-ability-comp-ProcessEvaluationTable",
    path: "/screens/hr-evaluation/evaluate/ability/comp/ProcessEvaluationTable",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/ability/comp/ProcessEvaluationTable.vue")
  },
  {
    name: "screens-hr-evaluation-my-results-comp-modals-AbilityEvalRadarChart",
    path: "/screens/hr-evaluation/my-results/comp/modals/AbilityEvalRadarChart",
    component: () => import("/app/pages/screens/hr-evaluation/my-results/comp/modals/AbilityEvalRadarChart.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-perform-comp-modals-EvalRateModal",
    path: "/screens/hr-evaluation/calculation/perform/comp/modals/EvalRateModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/EvalRateModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-other-items-comp-PageHeader",
    path: "/screens/hr-evaluation/calculation/total/other-items/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/other-items/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-Left",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/Left",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/Left.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-distribution-comp-GradeAdmin",
    path: "/screens/hr-evaluation/conf/basis/grade-distribution/comp/GradeAdmin",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/GradeAdmin.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-distribution-comp-GradeGroup",
    path: "/screens/hr-evaluation/conf/basis/grade-distribution/comp/GradeGroup",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/GradeGroup.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-distribution-comp-PageHeader",
    path: "/screens/hr-evaluation/conf/basis/grade-distribution/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-Step07EvaluatorConfigModal",
    path: "/screens/hr-evaluation/conf/settings/comp/Step07EvaluatorConfigModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/Step07EvaluatorConfigModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-targets-comp-modal-DeployEvalTargetModal",
    path: "/screens/hr-evaluation/conf/targets/comp/modal/DeployEvalTargetModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/targets/comp/modal/DeployEvalTargetModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-ability-comp-modals-EvalOpinionModal",
    path: "/screens/hr-evaluation/evaluate/ability/comp/modals/EvalOpinionModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/ability/comp/modals/EvalOpinionModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-modals-EvalOpinionModal",
    path: "/screens/hr-evaluation/evaluate/perform/comp/modals/EvalOpinionModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/EvalOpinionModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-modals-PlanActivityList",
    path: "/screens/hr-evaluation/evaluate/perform/comp/modals/PlanActivityList",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/PlanActivityList.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-PerformEvalModelSection",
    path: "/screens/hr-evaluation/evaluate/perform/comp/PerformEvalModelSection",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvalModelSection.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-PerformEvaluationHeader",
    path: "/screens/hr-evaluation/evaluate/perform/comp/PerformEvaluationHeader",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvaluationHeader.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-Right",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/Right",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/Right.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-BulkEvalTargetSettingsModal",
    path: "/screens/hr-evaluation/conf/settings/comp/BulkEvalTargetSettingsModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/BulkEvalTargetSettingsModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-Step07EvalTargetConfigModal",
    path: "/screens/hr-evaluation/conf/settings/comp/Step07EvalTargetConfigModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/Step07EvalTargetConfigModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-description-status-comp-PageHeader",
    path: "/screens/hr-evaluation/description/description-status/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/description/description-status/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-modals-PerformTmpltModal",
    path: "/screens/hr-evaluation/evaluate/perform/comp/modals/PerformTmpltModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/PerformTmpltModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-PerformEvalAiEvalPopover",
    path: "/screens/hr-evaluation/evaluate/perform/comp/PerformEvalAiEvalPopover",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvalAiEvalPopover.vue")
  },
  {
    name: "screens-hr-evaluation-progress-evaluators-comp-NotEndEvalTargetModal",
    path: "/screens/hr-evaluation/progress/evaluators/comp/NotEndEvalTargetModal",
    component: () => import("/app/pages/screens/hr-evaluation/progress/evaluators/comp/NotEndEvalTargetModal.vue")
  },
  {
    name: "screens-org-performance-org-performance-monitoring-org-diagram",
    path: "/screens/org-performance/org-performance-monitoring/org-diagram",
    meta: indexVVVKuShY8aWvg_P4wfKV5DeV_45Jfy8bpot0K_45a7vMIlsMeta || {},
    component: () => import("/app/pages/screens/org-performance/org-performance-monitoring/org-diagram/index.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-results-comp-PageHeader",
    path: "/screens/hr-evaluation/calculation/total/total-results/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-results/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-results-row-data-comp-modals-HreTimeSeriesModal",
    path: "/screens/hr-evaluation/results/row-data/comp/modals/HreTimeSeriesModal",
    component: () => import("/app/pages/screens/hr-evaluation/results/row-data/comp/modals/HreTimeSeriesModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-template-comp-PageHeader",
    path: "/screens/hr-evaluation/description/performance-template/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-template/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-common-comp-modals-EvalOpinionModalBase",
    path: "/screens/hr-evaluation/evaluate/common/comp/modals/EvalOpinionModalBase",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/common/comp/modals/EvalOpinionModalBase.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-modals-JobDescriptionModal",
    path: "/screens/hr-evaluation/evaluate/perform/comp/modals/JobDescriptionModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/JobDescriptionModal.vue")
  },
  {
    name: "screens-hr-evaluation-results-row-data-comp-modals-PerfStmtAllPdfModal",
    path: "/screens/hr-evaluation/results/row-data/comp/modals/PerfStmtAllPdfModal",
    component: () => import("/app/pages/screens/hr-evaluation/results/row-data/comp/modals/PerfStmtAllPdfModal.vue")
  },
  {
    name: "screens-hr-evaluation-results-row-data-comp-modals-TaskDescAllPdfModal",
    path: "/screens/hr-evaluation/results/row-data/comp/modals/TaskDescAllPdfModal",
    component: () => import("/app/pages/screens/hr-evaluation/results/row-data/comp/modals/TaskDescAllPdfModal.vue")
  },
  {
    name: "screens-org-performance-org-performance-monitoring-kpi-cascading",
    path: "/screens/org-performance/org-performance-monitoring/kpi-cascading",
    meta: indexqevcBjYcA7Pw612NTiupulDv5d6hnCfjEliHH7hmW00Meta || {},
    component: () => import("/app/pages/screens/org-performance/org-performance-monitoring/kpi-cascading/index.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-performance-items-comp-EvaluationGroup",
    path: "/screens/hr-evaluation/conf/basis/performance-items/comp/EvaluationGroup",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/EvaluationGroup.vue")
  },
  {
    name: "screens-hr-evaluation-my-results-comp-modals-AbilityEvalResultViewModal",
    path: "/screens/hr-evaluation/my-results/comp/modals/AbilityEvalResultViewModal",
    component: () => import("/app/pages/screens/hr-evaluation/my-results/comp/modals/AbilityEvalResultViewModal.vue")
  },
  {
    name: "screens-hr-evaluation-my-results-comp-modals-PerformEvalResultViewModal",
    path: "/screens/hr-evaluation/my-results/comp/modals/PerformEvalResultViewModal",
    component: () => import("/app/pages/screens/hr-evaluation/my-results/comp/modals/PerformEvalResultViewModal.vue")
  },
  {
    name: "screens-hr-evaluation-results-row-data-comp-modals-DownloadPreviewModal",
    path: "/screens/hr-evaluation/results/row-data/comp/modals/DownloadPreviewModal",
    component: () => import("/app/pages/screens/hr-evaluation/results/row-data/comp/modals/DownloadPreviewModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-performance-items-comp-EvaluationDetail",
    path: "/screens/hr-evaluation/conf/basis/performance-items/comp/EvaluationDetail",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/EvaluationDetail.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-performance-items-comp-PerformanceGroup",
    path: "/screens/hr-evaluation/conf/basis/performance-items/comp/PerformanceGroup",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/PerformanceGroup.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-performance-items-comp-PerformanceItems",
    path: "/screens/hr-evaluation/conf/basis/performance-items/comp/PerformanceItems",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/PerformanceItems.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-performance-items-comp-PerformancePanel",
    path: "/screens/hr-evaluation/conf/basis/performance-items/comp/PerformancePanel",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/PerformancePanel.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-template-comp-TemplateList",
    path: "/screens/hr-evaluation/description/performance-template/comp/TemplateList",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-template/comp/TemplateList.vue")
  },
  {
    name: "screens-hr-evaluation-results-results-view-comp-modals-AdjustReasonModal",
    path: "/screens/hr-evaluation/results/results-view/comp/modals/AdjustReasonModal",
    component: () => import("/app/pages/screens/hr-evaluation/results/results-view/comp/modals/AdjustReasonModal.vue")
  },
  {
    name: "screens-org-performance-org-performance-monitoring-org-grp-compare",
    path: "/screens/org-performance/org-performance-monitoring/org-grp-compare",
    meta: indexr1V13HOpvHzbSePAql7G9F0RJUoAccSeyDFXH2Q5LtoMeta || {},
    component: () => import("/app/pages/screens/org-performance/org-performance-monitoring/org-grp-compare/index.vue")
  },
  {
    name: "screens-org-performance-org-performance-monitoring-org-kpi-compare",
    path: "/screens/org-performance/org-performance-monitoring/org-kpi-compare",
    meta: indexZCaryG2ibvKO6Ah423DuvcrVujt_W9Ia95x1KGiShTUMeta || {},
    component: () => import("/app/pages/screens/org-performance/org-performance-monitoring/org-kpi-compare/index.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-perform-comp-modals-HreExcelResultModal",
    path: "/screens/hr-evaluation/calculation/perform/comp/modals/HreExcelResultModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/HreExcelResultModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-PageHeader",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-EvalSettingsTemplatePreviewModal",
    path: "/screens/hr-evaluation/conf/settings/comp/EvalSettingsTemplatePreviewModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/EvalSettingsTemplatePreviewModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-job-description-comp-modals-SearchModal",
    path: "/screens/hr-evaluation/description/job-description/comp/modals/SearchModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/job-description/comp/modals/SearchModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-PageHeader",
    path: "/screens/hr-evaluation/description/performance-description/comp/PageHeader",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/PageHeader.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-PerformEvalKpiKrReadonlyCards",
    path: "/screens/hr-evaluation/evaluate/perform/comp/PerformEvalKpiKrReadonlyCards",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvalKpiKrReadonlyCards.vue")
  },
  {
    name: "screens-hr-evaluation-results-row-data-comp-modals-HreAllExcelResultModal",
    path: "/screens/hr-evaluation/results/row-data/comp/modals/HreAllExcelResultModal",
    component: () => import("/app/pages/screens/hr-evaluation/results/row-data/comp/modals/HreAllExcelResultModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-items-comp-CompetencyInfoPanel",
    path: "/screens/hr-evaluation/conf/basis/competency-items/comp/CompetencyInfoPanel",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/CompetencyInfoPanel.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-items-comp-modals-NcsDictModal",
    path: "/screens/hr-evaluation/conf/basis/competency-items/comp/modals/NcsDictModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/NcsDictModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-job-description-comp-modals-SettingModal",
    path: "/screens/hr-evaluation/description/job-description/comp/modals/SettingModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/job-description/comp/modals/SettingModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-PerformEvalKrFeedbackEvalBadge",
    path: "/screens/hr-evaluation/evaluate/perform/comp/PerformEvalKrFeedbackEvalBadge",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvalKrFeedbackEvalBadge.vue")
  },
  {
    name: "screens-hr-evaluation-adjustment-comp-modals-ComponentHreAbilityResultModal",
    path: "/screens/hr-evaluation/adjustment/comp/modals/ComponentHreAbilityResultModal",
    component: () => import("/app/pages/screens/hr-evaluation/adjustment/comp/modals/ComponentHreAbilityResultModal.vue")
  },
  {
    name: "screens-hr-evaluation-adjustment-comp-modals-ComponentHrePerformResultModal",
    path: "/screens/hr-evaluation/adjustment/comp/modals/ComponentHrePerformResultModal",
    component: () => import("/app/pages/screens/hr-evaluation/adjustment/comp/modals/ComponentHrePerformResultModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-perform-comp-modals-BulkFormSettingsModal",
    path: "/screens/hr-evaluation/calculation/perform/comp/modals/BulkFormSettingsModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/BulkFormSettingsModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-perform-comp-modals-HreAbilityResultModal",
    path: "/screens/hr-evaluation/calculation/perform/comp/modals/HreAbilityResultModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/HreAbilityResultModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-perform-comp-modals-HrePerformResultModal",
    path: "/screens/hr-evaluation/calculation/perform/comp/modals/HrePerformResultModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/HrePerformResultModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-CellRenderer",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/CellRenderer",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/CellRenderer.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-items-comp-modals-CmptItemModal",
    path: "/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CmptItemModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CmptItemModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-job-description-comp-modals-CategoryModal",
    path: "/screens/hr-evaluation/description/job-description/comp/modals/CategoryModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/job-description/comp/modals/CategoryModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-SettingsPanel",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/SettingsPanel",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/SettingsPanel.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-items-comp-EvaluationGroupManager",
    path: "/screens/hr-evaluation/conf/basis/competency-items/comp/EvaluationGroupManager",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/EvaluationGroupManager.vue")
  },
  {
    name: "screens-hr-evaluation-description-description-status-comp-modals-PreviewModal",
    path: "/screens/hr-evaluation/description/description-status/comp/modals/PreviewModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/description-status/comp/modals/PreviewModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-job-description-comp-modals-AttachmentModal",
    path: "/screens/hr-evaluation/description/job-description/comp/modals/AttachmentModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/job-description/comp/modals/AttachmentModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-template-comp-CopyTemplateModal",
    path: "/screens/hr-evaluation/description/performance-template/comp/CopyTemplateModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-template/comp/CopyTemplateModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-PerformEvalEvidenceSummaryButtons",
    path: "/screens/hr-evaluation/evaluate/perform/comp/PerformEvalEvidenceSummaryButtons",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/PerformEvalEvidenceSummaryButtons.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-perform-comp-modals-CalculationSettingsModal",
    path: "/screens/hr-evaluation/calculation/perform/comp/modals/CalculationSettingsModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/perform/comp/modals/CalculationSettingsModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-items-comp-modals-CopyCmptGrpModal",
    path: "/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CopyCmptGrpModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CopyCmptGrpModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-insa-wizard-phases-InsaWizardPhaseGrp",
    path: "/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseGrp",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseGrp.vue")
  },
  {
    name: "screens-hr-evaluation-description-description-status-comp-modals-SendMailModal",
    path: "/screens/hr-evaluation/description/description-status/comp/modals/SendMailModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/description-status/comp/modals/SendMailModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-job-description-comp-tabs-JobDescriptionTabs",
    path: "/screens/hr-evaluation/description/job-description/comp/tabs/JobDescriptionTabs",
    component: () => import("/app/pages/screens/hr-evaluation/description/job-description/comp/tabs/JobDescriptionTabs.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-template-comp-TemplateFormEditor",
    path: "/screens/hr-evaluation/description/performance-template/comp/TemplateFormEditor",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-template/comp/TemplateFormEditor.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-CalculationPanel",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/CalculationPanel",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/CalculationPanel.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-items-comp-modals-CmptDictCopyModal",
    path: "/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CmptDictCopyModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CmptDictCopyModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-distribution-comp-GradeDistributionPanel",
    path: "/screens/hr-evaluation/conf/basis/grade-distribution/comp/GradeDistributionPanel",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/GradeDistributionPanel.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-scale-comp-modals-RatingGroupImportModal",
    path: "/screens/hr-evaluation/conf/basis/grade-scale/comp/modals/RatingGroupImportModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-scale/comp/modals/RatingGroupImportModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-insa-wizard-phases-InsaWizardPhaseCapa",
    path: "/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseCapa",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseCapa.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-insa-wizard-phases-InsaWizardPhaseInsa",
    path: "/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseInsa",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseInsa.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-insa-wizard-phases-InsaWizardPhaseMain",
    path: "/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseMain",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseMain.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-template-comp-TemplateTableEditor",
    path: "/screens/hr-evaluation/description/performance-template/comp/TemplateTableEditor",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-template/comp/TemplateTableEditor.vue")
  },
  {
    name: "screens-org-performance-org-performance-monitoring-org-performance-detail",
    path: "/screens/org-performance/org-performance-monitoring/org-performance-detail",
    meta: indexdUUWGz5WT4KT9mykby1YRBQeD2_uplegFInPNK7zHc4Meta || {},
    component: () => import("/app/pages/screens/org-performance/org-performance-monitoring/org-performance-detail/index.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-insa-wizard-phases-InsaWizardPhaseCycle",
    path: "/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseCycle",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseCycle.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-insa-wizard-phases-InsaWizardPhaseLevel",
    path: "/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseLevel",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseLevel.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-template-comp-CommonTemplateEditor",
    path: "/screens/hr-evaluation/description/performance-template/comp/CommonTemplateEditor",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-template/comp/CommonTemplateEditor.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-template-comp-TemplatePreviewModal",
    path: "/screens/hr-evaluation/description/performance-template/comp/TemplatePreviewModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-template/comp/TemplatePreviewModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-ai-perf-stmt-AiEvidenceSummaryButton",
    path: "/screens/hr-evaluation/evaluate/perform/comp/ai-perf-stmt/AiEvidenceSummaryButton",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/ai-perf-stmt/AiEvidenceSummaryButton.vue")
  },
  {
    name: "screens-org-performance-org-performance-monitoring-org-performance-summary",
    path: "/screens/org-performance/org-performance-monitoring/org-performance-summary",
    meta: indexfSAxUPfxfYsEIP1v_5SMaHn04JR2CEPQQbdPfLaaptQMeta || {},
    component: () => import("/app/pages/screens/org-performance/org-performance-monitoring/org-performance-summary/index.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-distribution-comp-GradeDistributionManager",
    path: "/screens/hr-evaluation/conf/basis/grade-distribution/comp/GradeDistributionManager",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/GradeDistributionManager.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-insa-wizard-phases-InsaWizardPhasePeriod",
    path: "/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhasePeriod",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhasePeriod.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-insa-wizard-phases-InsaWizardPhaseResult",
    path: "/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseResult",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseResult.vue")
  },
  {
    name: "screens-hr-evaluation-conf-targets-comp-modal-OtherManagerInvolvedEvalTargetModal",
    path: "/screens/hr-evaluation/conf/targets/comp/modal/OtherManagerInvolvedEvalTargetModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/targets/comp/modal/OtherManagerInvolvedEvalTargetModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-SearchModal",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/SearchModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/SearchModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-dictionary-comp-CompetencyGroupSidebar",
    path: "/screens/hr-evaluation/conf/basis/competency-dictionary/comp/CompetencyGroupSidebar",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-dictionary/comp/CompetencyGroupSidebar.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-items-comp-modals-CmptDictModDataModal",
    path: "/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CmptDictModDataModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CmptDictModDataModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-items-comp-modals-CommLdrCmptDictModal",
    path: "/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CommLdrCmptDictModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CommLdrCmptDictModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-insa-wizard-phases-InsaWizardPhaseAbility",
    path: "/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseAbility",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseAbility.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-insa-wizard-phases-InsaWizardPhasePerfmdl",
    path: "/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhasePerfmdl",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhasePerfmdl.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-insa-wizard-phases-InsaWizardPhasePerform",
    path: "/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhasePerform",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhasePerform.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-SettingModal",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/SettingModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/SettingModal.vue")
  },
  {
    name: "screens-hr-evaluation-evaluate-perform-comp-modals-PerformEvalEvidenceSummaryModal",
    path: "/screens/hr-evaluation/evaluate/perform/comp/modals/PerformEvalEvidenceSummaryModal",
    component: () => import("/app/pages/screens/hr-evaluation/evaluate/perform/comp/modals/PerformEvalEvidenceSummaryModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-dictionary-comp-CompetencyDetailManager",
    path: "/screens/hr-evaluation/conf/basis/competency-dictionary/comp/CompetencyDetailManager",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-dictionary/comp/CompetencyDetailManager.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-CategoryModal",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/CategoryModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/CategoryModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-modals-TargetAddModal",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/TargetAddModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/TargetAddModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-tabs-FormTypeTemplate",
    path: "/screens/hr-evaluation/description/performance-description/comp/tabs/FormTypeTemplate",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/tabs/FormTypeTemplate.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-tabs-ItemTypeTemplate",
    path: "/screens/hr-evaluation/description/performance-description/comp/tabs/ItemTypeTemplate",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/tabs/ItemTypeTemplate.vue")
  },
  {
    name: "screens-org-performance-org-performance-monitoring-org-performance-action-plan",
    path: "/screens/org-performance/org-performance-monitoring/org-performance-action-plan",
    meta: index2CDRTnfYtC__45VkyjCnYwDpaSA4s_SQLthHaaT_45JlOH8Meta || {},
    component: () => import("/app/pages/screens/org-performance/org-performance-monitoring/org-performance-action-plan/index.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-distribution-comp-modals-GradeGroupImportModal",
    path: "/screens/hr-evaluation/conf/basis/grade-distribution/comp/modals/GradeGroupImportModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/modals/GradeGroupImportModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-settings-comp-insa-wizard-phases-InsaWizardPhaseMultiphase",
    path: "/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseMultiphase",
    component: () => import("/app/pages/screens/hr-evaluation/conf/settings/comp/insa-wizard-phases/InsaWizardPhaseMultiphase.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-AttachmentModal",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/AttachmentModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/AttachmentModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-modals-TargetRatioModal",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/TargetRatioModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/TargetRatioModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-modals-EvalGrpImportModal",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/EvalGrpImportModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/EvalGrpImportModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-competency-items-comp-modals-CompetencyGroupImportModal",
    path: "/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CompetencyGroupImportModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/competency-items/comp/modals/CompetencyGroupImportModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-panels-FeedbackAsidePanel",
    path: "/screens/hr-evaluation/description/performance-description/comp/panels/FeedbackAsidePanel",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/panels/FeedbackAsidePanel.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-performance-items-comp-modals-EvaluationGroupImportModal",
    path: "/screens/hr-evaluation/conf/basis/performance-items/comp/modals/EvaluationGroupImportModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/modals/EvaluationGroupImportModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-modals-GradeManagementModal",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/GradeManagementModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/GradeManagementModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-performance-items-comp-modals-PerformanceGroupImportModal",
    path: "/screens/hr-evaluation/conf/basis/performance-items/comp/modals/PerformanceGroupImportModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/performance-items/comp/modals/PerformanceGroupImportModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-modals-TotTargetRatioSection",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/TotTargetRatioSection",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/TotTargetRatioSection.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-distribution-comp-modals-GradeDistributionImportModal",
    path: "/screens/hr-evaluation/conf/basis/grade-distribution/comp/modals/GradeDistributionImportModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/modals/GradeDistributionImportModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-modals-BulkAdjustSettingsModal",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/BulkAdjustSettingsModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/BulkAdjustSettingsModal.vue")
  },
  {
    name: "screens-hr-evaluation-conf-basis-grade-distribution-comp-modals-GradeDistributionDownloadModal",
    path: "/screens/hr-evaluation/conf/basis/grade-distribution/comp/modals/GradeDistributionDownloadModal",
    component: () => import("/app/pages/screens/hr-evaluation/conf/basis/grade-distribution/comp/modals/GradeDistributionDownloadModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-modals-BulkCoordUserSettingsModal",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/BulkCoordUserSettingsModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/BulkCoordUserSettingsModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-modals-TotCalculationSettingsModal",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/TotCalculationSettingsModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/TotCalculationSettingsModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-ai-generate-Step3Generating",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/Step3Generating",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/Step3Generating.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-ai-generate-Step4ReviewApply",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/Step4ReviewApply",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/Step4ReviewApply.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-PerformStatementContentModal",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/PerformStatementContentModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/PerformStatementContentModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-modals-ComponentHreAbilityResultModal",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/ComponentHreAbilityResultModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/ComponentHreAbilityResultModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-modals-ComponentHrePerformResultModal",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/ComponentHrePerformResultModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/ComponentHrePerformResultModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-ai-generate-item-Step1WriteMode",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/Step1WriteMode",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/Step1WriteMode.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-ai-generate-Step1TemplateSelect",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/Step1TemplateSelect",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/Step1TemplateSelect.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-ai-generate-Step2EvidenceSelect",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/Step2EvidenceSelect",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/Step2EvidenceSelect.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-ai-generate-item-Step3Generating",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/Step3Generating",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/Step3Generating.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-modals-ComponentHreAbilityTotResultModal",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/ComponentHreAbilityTotResultModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/ComponentHreAbilityTotResultModal.vue")
  },
  {
    name: "screens-hr-evaluation-calculation-total-total-calculation-comp-modals-ComponentHrePerformTotResultModal",
    path: "/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/ComponentHrePerformTotResultModal",
    component: () => import("/app/pages/screens/hr-evaluation/calculation/total/total-calculation/comp/modals/ComponentHrePerformTotResultModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-ai-generate-item-Step4ReviewApply",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/Step4ReviewApply",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/Step4ReviewApply.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-ai-generate-item-AiPerfItemHelpTip",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/AiPerfItemHelpTip",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/AiPerfItemHelpTip.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-ai-generate-AiPerfStmtGenerateModal",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/AiPerfStmtGenerateModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate/AiPerfStmtGenerateModal.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-ai-generate-item-Step2EvidenceSelect",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/Step2EvidenceSelect",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/Step2EvidenceSelect.vue")
  },
  {
    name: "screens-hr-evaluation-description-performance-description-comp-modals-ai-generate-item-AiPerfItemGenerateModal",
    path: "/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/AiPerfItemGenerateModal",
    component: () => import("/app/pages/screens/hr-evaluation/description/performance-description/comp/modals/ai-generate-item/AiPerfItemGenerateModal.vue")
  }
]